(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("ui"), require("module-metro-users"), require("angular-sanitize"), require("angular"), require("XmSdk"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core", "ui", "module-metro-users", "angular-sanitize", "angular", "XmSdk", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["MBTaskRunner"] = factory(require("base"), require("core"), require("ui"), require("module-metro-users"), require("angular-sanitize"), require("angular"), require("XmSdk"), require("lodash"));
	else
		root["MBTaskRunner"] = factory(root["base"], root["core"], root["ui"], root["module-metro-users"], root["angular-sanitize"], root["angular"], root["XmSdk"], root["lodash"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_25__, __WEBPACK_EXTERNAL_MODULE_39__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'module-metro-components';

	    var contextRoot = '';
	    var featuresRoot = 'static/features/[BBHOST]';

	    if (window.b$ && window.b$.portal && window.b$.portal.config) {
	        if (window.b$.portal.config.serverRoot) {
	            contextRoot = window.b$.portal.config.serverRoot;
	        }

	        /**
	         * Widget/Module can't KNOW upper structure only guess
	         * window.b$.portal.config.featuresRoot
	         * added to add possibility to mock it
	         */
	        if (window.b$.portal.config.featuresRoot) {
	            featuresRoot = window.b$.portal.config.featuresRoot;
	        }
	    }

	    var templatePath = [contextRoot, featuresRoot, module.name, 'scripts/templates', ''].join('/');

	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);
	    var ui = __webpack_require__(5);
	    var users = __webpack_require__(6);

	    __webpack_require__(7);

	    var deps = [core.name, ui.name, users.name, 'ngSanitize'];

	    //code goes here

	    /**
	    *  @ngInject
	    */
	    module.exports = base.createModule(module.name, deps).filter(__webpack_require__(8)).filter(__webpack_require__(9)).constant('TEMPLATE_PATH', templatePath).constant('metAccordionConfig', {
	        closeOthers: true
	    }).factory(__webpack_require__(10)).controller(__webpack_require__(11)).directive(__webpack_require__(12)).directive(__webpack_require__(13)).directive(__webpack_require__(14)).directive(__webpack_require__(15)).directive(__webpack_require__(16)).directive(__webpack_require__(18)).directive(__webpack_require__(19)).directive(__webpack_require__(20)).directive(__webpack_require__(21)).directive(__webpack_require__(22)).directive(__webpack_require__(23)).directive(__webpack_require__(24)).directive(__webpack_require__(26)).directive(__webpack_require__(27)).directive(__webpack_require__(28)).directive(__webpack_require__(29)).directive(__webpack_require__(30)).directive(__webpack_require__(31)).directive(__webpack_require__(32)).directive(__webpack_require__(33)).directive(__webpack_require__(34)).directive(__webpack_require__(35)).directive(__webpack_require__(36)).directive(__webpack_require__(37)).directive(__webpack_require__(38)).directive(__webpack_require__(40)).directive(__webpack_require__(41));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /**
	    * Filter for formatting IBAN numbers (groups of 4 numbers)
	    */

	    exports.iban = function () {
	        return function (input) {
	            return input.match(/(\d|\D){1,4}/g).join(' ');
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.replace = function () {
	        return function (input, search, replace) {
	            var filteredString = '';

	            if (input) {
	                filteredString = input.replace(new RegExp(search, 'g'), replace);
	            }

	            return filteredString;
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 * Factories
	 * @module factories
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject
	    /**
	     * @param {ng.IHttpService} $http
	     * @param {ng.IQService} $q
	     * @param {ng.ILogService} $log
	     */

	    exports.metTooltipFactory = function mandatesFactory($http, $q, $log) {

	        // Initiate the new mandate
	        function getTooltip(category, key, placement, inline) {
	            var tooltip = null;
	            if (!category) {
	                $log.error('Missing tooltip category for key: ' + key);
	            } else if (!key) {
	                $log.error('Missing tooltip key for category: ' + category);
	            } else {
	                var folder = window.tooltips[category];
	                if (folder) {
	                    tooltip = folder[key];
	                }

	                if (!tooltip && b$.portal.loggedInUserRole === 'admin') {
	                    tooltip = {
	                        key: key,
	                        category: key,
	                        contents: '<p>Create tooltip with name ' + key + ' in ' + category + '</p>',
	                        inline: inline,
	                        icon: 'warning'
	                    };
	                }
	            }
	            return tooltip;
	        }
	        return {
	            getTooltip: getTooltip
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.MetAccordionController = function ($scope, $attrs, metAccordionConfig) {
	        // This array keeps track of the accordion groups, they should be globall
	        this.groups = [];

	        // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	        this.closeOthers = function (openGroup) {

	            var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : metAccordionConfig.closeOthers;
	            if (closeOthers) {
	                angular.forEach(this.groups, function (group) {
	                    if (group !== openGroup) {
	                        group.isOpen = false;
	                    }
	                });
	            }
	        };

	        // This is called from the accordion-group directive to add itself to the accordion
	        this.addGroup = function (groupScope) {
	            var that = this;
	            this.groups.push(groupScope);

	            groupScope.$on('$destroy', function (event) {
	                that.removeGroup(groupScope);
	            });
	        };

	        // This is called from the accordion-group directive when to remove itself
	        this.removeGroup = function (group) {
	            var index = this.groups.indexOf(group);
	            if (index !== -1) {
	                this.groups.splice(index, 1);
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.list = function () {
	        return {
	            restrict: 'E',
	            template: '<div ng-repeat="model in model.items">' + '   <element/>' + '</div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /*
	     * Usage: Wherever you need an editable field, insert <ice pref="nameOfPrefToUse"></ice>.
	     *
	     * The pref attribute controls which widget preference will be used to load and save to.
	     */

	    exports.ice = function () {
	        return {
	            restrict: 'E',
	            scope: {},
	            controller: /* @ngInject */function controller($scope, $attrs, $element, lpWidget) {
	                $scope.designMode = window.bd && window.bd.designMode || false;
	                $scope.text = lpWidget.getPreference($attrs.pref);

	                $scope.save = function () {
	                    lpWidget.setPreference($attrs.pref, $element.text());
	                    lpWidget.model.save();
	                };
	            },
	            template: '<span contenteditable="{{designMode}}" ng-keyup="save()">{{text}}</span>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.metSpinner = function () {
	        return {
	            restrict: 'E',
	            replace: true,
	            template: '<div class="container loading">' + '   <div class="text-center">' + '       <i class="fa fa-1x fa-spinner fa-spin"></i>' + '   </div>' + '</div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 * Directive Metro Search
	 * @module Search Component
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.metSearch = function (TEMPLATE_PATH) {
	        return {
	            restrict: 'E',
	            require: ['^form'],
	            replace: true,
	            scope: {
	                model: '=ngModel',
	                btnText: '@',
	                inputPlaceholder: '@',
	                searchFn: '&',
	                smallSearch: '=',
	                errorMessage: '@',
	                maxlength: '@',
	                minlength: '@',
	                required: '=',
	                validCharacters: '@'
	            },
	            templateUrl: TEMPLATE_PATH + 'metSearch.html',
	            link: function link(scope, element, attrs, ctrls) {
	                scope.form = ctrls[0];
	                scope.errorObject = scope.form.search.$error;
	                var searchInput = element.find('.form-control');

	                /* when search icon inside input is clicked focus the input
	                 for user to enter search params */
	                scope.focusSearchInput = function () {
	                    searchInput.focus();
	                };

	                scope.changeField = function (event) {
	                    scope.searched = false;
	                    if (event.keyCode === 13) {
	                        scope.search();
	                    }
	                };

	                // keypress validation for maxLength to prevent
	                // user input more then max characters allowed
	                scope.validateLength = function (event) {
	                    // check event for backspace to prevent disabling backspace to delete value
	                    // in input in firefox and ie. This validation is done only if maxLength property is defined
	                    if (scope.maxlength !== undefined && event.target.value.length >= scope.maxlength && event.keyCode !== 8) {
	                        event.preventDefault ? event.preventDefault() : event.returnValue = false;
	                    }
	                };

	                scope.search = function () {

	                    scope.searched = true;

	                    if (scope.form.search.$valid) {
	                        scope.searchFn();
	                        searchInput.value = '';
	                        scope.searched = false;
	                    }
	                };
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /**
	     * @type {ng.IAngularStatic}
	     */

	    var angular = __webpack_require__(17);

	    /**
	     * Directive for drawing the lightbox
	     * Using Bootstrap's Modal Component
	     */
	    exports.metLightbox = function () {
	        return {
	            restrict: 'E',
	            scope: {
	                lightboxName: '@name', // The name of the modal element; String
	                closeIcon: '@showCloseIcon', // Show the close (x) icon; Boolean
	                closeButton: '@showCloseButton', // Show the close button within a footer; Boolean
	                closeButtonLabel: '@', // The label of the close button; String
	                show: '=showOnLoad', // Show the modal on page load (also shows the modal every time it changes from false to true); Boolean
	                animate: '@', // Enables the animation of the modal; Boolean
	                size: '@', // The size of the modal, Bootstrap style: sm, lg, empty for default; String
	                backdrop: '@clickBackdrop',
	                customClasses: '@', // Any classes to add to the modal element, separated by space; String
	                actionOnClose: '&',
	                infiniteScrollCallback: '&?',
	                infiniteScrollAvailable: '=?',
	                infiniteScrollLoading: '=?'
	            },
	            replace: true,
	            transclude: true,
	            link: {
	                pre: function pre(scope, element) {
	                    element.remove();
	                    angular.element('.pageContainer').prepend(element);
	                },
	                post: function post(scope, element, attrs, ctrls, transcludeFn) {
	                    var modalElement = element.find('.modal');
	                    var modalDialog = element.find('.modal-dialog');
	                    var modalBackdrop = element.find('.modal-backdrop');

	                    scope.lightboxName = scope.lightboxName || 'myModal';
	                    scope.closeButtonLabel = scope.closeButtonLabel || 'Close';

	                    modalElement.addClass(scope.customClasses);

	                    if (scope.animate) {
	                        modalElement.addClass('fade');
	                    }

	                    if (scope.size) {
	                        modalDialog.addClass('modal-' + scope.size);
	                    }

	                    if (!scope.backdrop) {
	                        modalElement.data('backdrop', 'static');
	                    }

	                    if (scope.backdrop) {
	                        modalBackdrop.on('mouseup', function () {
	                            scope.$apply(function () {
	                                scope.show = false;
	                            });
	                            scope.actionOnClose && scope.actionOnClose();
	                        });
	                    }

	                    if (scope.infiniteScrollCallback && scope.infiniteScrollAvailable) {
	                        element.find('.modal-content').scroll(function () {
	                            if (scope.infiniteScrollAvailable && !scope.infiniteScrollLoading && angular.element(this).scrollTop() + angular.element(this).innerHeight() === this.scrollHeight) {
	                                scope.infiniteScrollCallback();
	                            }
	                        });
	                    }

	                    scope.$watch('show', function (newValue) {
	                        if (newValue) {
	                            modalElement.removeClass('hide').addClass('fade in');
	                            modalBackdrop.removeClass('hide').addClass('fade in');

	                            angular.element('body').css({ overflow: 'visible' });
	                            angular.element('html').css({ overflow: 'visible', position: 'fixed', width: '100%' }).addClass('lightbox-open'); // hack for firefox on android
	                        } else {
	                            modalElement.addClass('hide').removeClass('fade in');
	                            modalBackdrop.addClass('hide').removeClass('fade in');

	                            angular.element('body').css({ overflow: 'auto' });
	                            angular.element('html').css({ overflow: 'auto', position: 'static' }).removeClass('lightbox-open'); // hack for firefox on android
	                        }
	                    });

	                    modalElement.on('hide.bs.modal', function () {

	                        if (!scope.show) {
	                            return;
	                        }

	                        scope.$apply(function () {
	                            scope.show = false;
	                        });
	                    });

	                    scope.closeModal = function () {
	                        scope.show = false;
	                        scope.actionOnClose && scope.actionOnClose();
	                    };

	                    transcludeFn(scope.$parent, function (clone) {
	                        element.find('[met-transclude]').append(clone);
	                    });
	                }
	            },
	            template: '<div class="met-lightbox">' + '   <div class="modal hide" id="{{lightboxName}}" tabindex="-1" role="dialog" aria-labelledby="{{lightboxName}}Label">' + '       <div class="modal-dialog" role="document">' + '           <div class="modal-content">' + '               <button type="button" ng-show="{{closeIcon}}" class="close lightbox-close-x" data-dismiss="modal" aria-label="Close" ng-click="closeModal()">' + '                   <span aria-hidden="true"><i class="fa fa-times"></i></span>' + '               </button>' + '              <div met-transclude></div>' + '              <div class="met-footer" ng-show="{{closeButton}}">' + '                  <button type="button" class="pull-right btn btn-default" ng-click="closeModal()">{{closeButtonLabel}}</button>' + '              </div>' + '          </div>' + '      </div>' + '   </div>' + '   <div class="modal-backdrop hide"></div>' + '</div>'
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /**
	     * Directive for drawing the Header component
	     */

	    exports.metHeader = function () {
	        return {
	            restrict: 'AE',
	            scope: {
	                iconShow: '@', // To show or not an icon before the text; Boolean, Required
	                iconClass: '@', // The Font awesome class name of the icon; String
	                iconColor: '@' // To change the color of the icon, hex color (#ffffff); String
	            },
	            replace: true,
	            transclude: true,
	            template: '<div class="met-header">' + '   <div class="header-icon" ng-show="{{iconShow}}"><i class="fa {{iconClass}}" style="color: {{iconColor}}"></i></div>' + '   <div class="header-text">' + '       <div ng-transclude></div>' + '   </div>' + '</div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 * Directive for drawing the Alert component
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.metAlert = function () {
	        return {
	            restrict: 'E',
	            scope: {
	                alertType: '@type', // The type of the modal element, Bootstrap style: warning (default), success, info, danger; String, Required
	                dismissable: '@' // To show the dismiss button
	            },
	            replace: true,
	            transclude: true,
	            template: '<div class="met-alert alert alert-{{alertType}}" role="alert">' + '   <button ng-show="{{dismissable}}" type="button" class="close" data-dismiss="alert" aria-label="Close">' + '       <span aria-hidden="true">&times;</span>' + '   </button>' + '   <div ng-transclude></div>' + '</div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.listItem = function () {
	        return {
	            restrict: 'E',
	            replace: true,
	            template: '<div class="met-list">' + '   <div class="met-list-item" data-id="id">' + '       <div class="item-clock pull-left" ng-show="model.locked">' + '           <div class="item-inner">' + '               <i class="fa fa-clock-o fa-lg"></i>' + '           </div>' + '       </div>' + '       <div class="item-checkbox pull-left" ng-show="model.unassigned && !model.locked">' + '           <div class="item-inner">' + '               <met-checkbox data-checked="markedForDeletion"></met-checkbox>' + '           </div>' + '       </div>' + '       <div class="item-content">' + '           <div class="item-inner">' + '               <h3><a ng-show="!model.locked" href ng-click="model.linkAction(model.id)">{{model.label}}</a><span ng-show="model.locked">{{model.label}}</span></h3>' + '               <p>{{model.description}}</p>' + '           </div>' + '       </div>' + '       <div class="item-view pull-right" ng-show="model.showView">' + '           <div class="item-inner">' + '               <a ng-click="model.viewAction(model.id)" class="fa fa-eye fa-lg"></a>' + '           </div>' + '       </div>' + '   </div>' + '</div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.listItemLoading = function () {
	        return {
	            restrict: 'E',
	            scope: true,
	            replace: true,
	            template: '<div class="text-center" ng-show="loading"> <i class="fa fa-2x fa-spinner fa-spin"></i> </div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 * Directives
	 * @module Accordion Component
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.accordionMetro = function () {
	        return {
	            restrict: 'E',
	            replace: true,
	            template: '<div>' + '   <div class="ui-accordion-title" ng-click="open()">' + '<p>{{model.title}}</p><p>{{model.text}}</p><a href="#"></a>>Show</a></div><div ng-repeat="model in model.list"><element model="model"></element></div></div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.includeExcludeBox = function (TEMPLATE_PATH) {
	        return {
	            restrict: 'E',
	            controller: /* @ngInject */function controller($scope, $element, $log) {
	                $scope.mainCtrl.includedItems = {};
	                $scope.mainCtrl.excludedItems = {};
	                $scope.mainCtrl.includeAll = false;
	                $scope.mainCtrl.excludeAll = false;
	                $scope.mainCtrl.actionType = null;

	                $log.log($scope.readOnly);

	                /**
	                 * _containsObj()
	                 * Verify if the array
	                 * contains account
	                 */
	                var containsObj = function containsObj(obj, list) {
	                    var i;
	                    for (i = 0; i < list.length; i++) {
	                        if (obj.name === list[i].name && obj.id === list[i].id) {
	                            return true;
	                        }
	                    }
	                    return false;
	                };

	                /**
	                 * _categoriseItem()
	                 * INC or EXC
	                 * account
	                 */
	                var categoriseItem = function categoriseItem(item, isInclude) {
	                    var list = isInclude ? $scope.mainCtrl.includedItems : $scope.mainCtrl.excludedItems;
	                    var bucket = list[item.typeDescription] || [];

	                    if (isInclude) {
	                        $scope.mainCtrl.actionType = 'INC';
	                    } else {
	                        $scope.mainCtrl.actionType = 'EXC';
	                    }

	                    if (!$scope.isCategory) {
	                        if (!containsObj(item, bucket)) {
	                            bucket.push(item);
	                            list[item.typeDescription] = bucket;
	                        }
	                    } else {
	                        $scope.create.accountGroup.typeAction.push({
	                            actionType: $scope.mainCtrl.actionType,
	                            accountType: item.id
	                        });

	                        list[item.description] = 1;
	                    }
	                };

	                window.gadgets.pubsub.subscribe('category', function () {
	                    $scope.isCategory = true;
	                });

	                window.gadgets.pubsub.subscribe('account', function () {
	                    $scope.isCategory = false;
	                });

	                /**
	                 * $scope.inclExclItem
	                 * INC or EXC
	                 * account calling _categoriseItem()
	                 */
	                $scope.mainCtrl.inclExclItem = function (inclFlag) {
	                    categoriseItem($scope.mainCtrl.selectedAccItem, !!inclFlag);
	                    $scope.$emit('item-list-changed');
	                };

	                /**
	                 * $scope.inclExclAll
	                 * INC or EXC
	                 * ALL accounts
	                 */
	                $scope.mainCtrl.inclExclAll = function (inclFlag) {
	                    $scope.mainCtrl.includedItems = {};
	                    $scope.mainCtrl.excludedItems = {};

	                    if (inclFlag && $scope.mainCtrl.includeAll) {
	                        $scope.create.accountGroup.typeAction = [];
	                    } else if (inclFlag && !$scope.mainCtrl.includeAll) {
	                        $scope.create.accountGroup.typeAction = [{
	                            actionType: 'ALL',
	                            accountType: null
	                        }];
	                    } else if (!inclFlag && $scope.mainCtrl.excludeAll) {
	                        $scope.create.accountGroup.typeAction = [];
	                    } else if (!inclFlag && !$scope.mainCtrl.excludeAll) {
	                        $scope.create.accountGroup.typeAction = null;
	                    }
	                    $scope.$emit('item-list-changed');
	                };

	                /**
	                 * $scope.removeCategory
	                 * Remove category
	                 */
	                $scope.mainCtrl.removeCategory = function (category, inclFlag) {
	                    var items = inclFlag ? $scope.mainCtrl.includedItems : $scope.mainCtrl.excludedItems;

	                    for (var key in items) {
	                        if (key === category) {
	                            delete items[key];
	                            $scope.$emit('item-list-changed');
	                            return;
	                        }
	                    }
	                };

	                /**
	                 * $scope.removeItem
	                 * Remove account
	                 */
	                $scope.mainCtrl.removeItem = function (category, index, inclFlag) {
	                    // remove item and check if the included or excluded list has no items
	                    // for that category in order to delete it
	                    if (inclFlag) {
	                        $scope.mainCtrl.includedItems[category].splice(index, 1);

	                        if ($scope.mainCtrl.includedItems[category].length === 0) {
	                            delete $scope.mainCtrl.includedItems[category];
	                        }
	                    } else {
	                        $scope.mainCtrl.excludedItems[category].splice(index, 1);

	                        if ($scope.mainCtrl.excludedItems[category].length === 0) {
	                            delete $scope.mainCtrl.excludedItems[category];
	                        }
	                    }
	                    $scope.$emit('item-list-changed');
	                };
	            },
	            templateUrl: TEMPLATE_PATH + 'includeExcludeBox.html'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var sdkinit = __webpack_require__(25);
	    // @ngInject
	    exports.metScaPayment = function (TEMPLATE_PATH, lpCoreI18n) {
	        return {
	            restrict: 'E',
	            scope: {
	                startjourney: '=?startjourney',
	                canceljourney: '&',
	                endjourneyfirst: '&',
	                request: '=?request',
	                submit: '&submit',
	                startregistration: '=?startregistration'
	            },
	            controller: /* @ngInject */function controller($scope, $timeout, $element, $log, metroTransmit, metroUiHandler, lpCoreBus, lpUsersAuthentication, metroContext, metroMeta, metroTagging) {

	                $scope.endjourneyfirst;
	                var resolveSoftTokenPromise;
	                var forms = ['COB_SCA_NO_HT_form', 'COB_SCA_HT_form', 'COB_SCA_ST_form', 'hrp_cob_soft_token_password_form', 'COB_SCA_ST_PW_form', 'cob_mobile_auth_registration_form']; //'hard_token_form',
	                var currentScenario = null;
	                var errSoftokenFailure;
	                var hrpDataRequest;

	                $scope.formLoad = false;
	                $scope.modalHeader = "";
	                var authJourney;
	                $scope.$watch('startjourney', function (newValue) {
	                    metroUiHandler.resetJsonProviderData();
	                    $scope.hrp = {};
	                    $scope.isSoftokenJourney = false;
	                    $scope.isBulkBatchJourney = false;
	                    $scope.softokenDeclined = false;
	                    $scope.modalHeader = "";
	                    $scope.totpQRImage = "";
	                    //to do : remove 1 flag
	                    $scope.softokenPasswordJourney = false;
	                    errSoftokenFailure = "";
	                    $scope.userId = JSON.parse(localStorage.getItem('session')).username;
	                    if (newValue) {
	                        if ($scope.request && $scope.request.payment_amount) {
	                            if ($scope.request.payment_ccy) {
	                                $scope.payment_ccy = $scope.request.payment_ccy;
	                            }
	                            $scope.decimalfy();
	                        }
	                        authJourney = "payment_authentication_journey";
	                        var subjourney = $scope.request && $scope.request.sub_flow_type1 ? $scope.request.sub_flow_type1 : '';
	                        metroUiHandler.setJourney('user_hrp_journey', subjourney);

	                        if ($scope.request.sub_flow_type1) {
	                            switch ($scope.request.sub_flow_type1) {
	                                case 'standing_order':
	                                case 'amend_payment_items':
	                                case 'recurring_transfers':
	                                case 'single_held_transactions':
	                                case 'single_payment_new_payee':
	                                case 'batch_payment':
	                                case 'outstanding_payments_management':
	                                case 'bulk_payment':
	                                    {
	                                        $scope.modalHeader = "Authenticating a payment";
	                                        break;
	                                    }
	                                case 'beneficiary':
	                                case 'bulk_ben':
	                                case 'mandates':
	                                case 'account_groups':
	                                case 'user':
	                                case 'access_groups':
	                                    {
	                                        $scope.modalHeader = "Update your information";
	                                        break;
	                                    }
	                                case 'password-update':
	                                    {
	                                        $scope.modalHeader = "Update Password";
	                                        authJourney = "user_change_password_journey";
	                                        break;
	                                    }
	                                default:
	                                    {
	                                        $scope.modalHeader = "Process";
	                                    }
	                            }
	                        }

	                        if ($scope.request.isScaCards) {

	                            if ($scope.request.isPA) {
	                                $scope.modalHeader = "Authenticating online payments";
	                            } else {
	                                $scope.modalHeader = "Authenticating your card";
	                            }

	                            metroTagging.onpageLoadTag('Card Ecommerce | Metrobank', document.location.pathname + "/modal-sca-stepup/" + $scope.modalHeader.toLowerCase().replace(" ", "-"), metroMeta.EVENT.pageLoaded);

	                            /* Card approve journey  COB-SCA-G003*/
	                            metroTagging.onEventTag(metroMeta.EVENTNAME.goal, $scope.request.isPA ? metroMeta.TRANSMIT.CARDS.CONFIRMACTIONWITHAPPROVAL : metroMeta.TRANSMIT.CARDS.CONFIRMACTIONWITHCARDAPPROVAL, metroMeta.TRANSMIT.SCA.CARDAPPROVALJOURNEYSTARTEVENTDETAIL, metroMeta.EVENT.goal);
	                        }

	                        $scope.modulename = metroTransmit.formatMdoduleString($scope.request);

	                        //$scope.request.isLocal=true;
	                        metroTransmit.invokePolicy(authJourney, $scope.request, null).then(function (response) {
	                            if (response._internalData.json_data.authentication_policy /* && response._internalData.json_data.authentication_policy !== "EXEMPTED" */) {
	                                    if (response._internalData.json_data.authentication_policy !== "EXEMPTED") {
	                                        $scope.startProcess();
	                                    }
	                                    $scope.request.authentication_policy = response._internalData.json_data.authentication_policy;
	                                    hrpDataRequest = angular.copy($scope.request);
	                                    if (hrpDataRequest && hrpDataRequest.payment_ccy) {
	                                        var currencySymbol = lpCoreI18n.formatCurrency(0, hrpDataRequest.payment_ccy);
	                                        currencySymbol = currencySymbol.toString();
	                                        currencySymbol = currencySymbol.split('0')[0];
	                                        if (currencySymbol) {
	                                            hrpDataRequest.payment_ccy = currencySymbol;
	                                        }
	                                    }
	                                    hrpjourney();
	                                } else if (response._internalData.json_data.updated_password == true) {
	                                $scope.endProcess(null, null, true);
	                            } else {
	                                var jwt = sessionStorage.getItem('sessionJwt');
	                                $scope.endProcess(jwt, null);
	                            }
	                        }).catch(function (err) {
	                            $scope.loading = false;
	                            var error = err._data;

	                            if (metroUiHandler.getKeyValue("softokenErrorMessage")) {
	                                errSoftokenFailure = metroUiHandler.getKeyValue("softokenErrorMessage");
	                            }
	                            if (authJourney === 'user_change_password_journey') {
	                                var errormsg = 'generic';
	                                if (error && error.failure_data && error.failure_data.reason && error.failure_data.reason.data || errSoftokenFailure) {
	                                    if (error.failure_data && error.failure_data.reason.data.password_constraint_error == true) {
	                                        errormsg = "passwordconstrainerror";
	                                    } else if (error.failure_data && (error.failure_data.reason.data.incorrect_attempt || error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL") || errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL") {
	                                        errormsg = "incorrect";
	                                    } else if (error.failure_data && error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING" || errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING") {
	                                        errormsg = "oneattemptleft";
	                                    } else if (error.failure_data.reason.data.errors[0].id == "SCACHK_PROCESS_BLOCKED") {
	                                        errormsg = "blockedprocess";
	                                    } else if (error.failure_data && (error.failure_data.reason.data.account_locked || error.failure_data.reason.data.errors[0].id == "LOGIN_FAILURE_LOCKED_OUT") || errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING") {
	                                        window.sessionStorage.setItem('qParams', JSON.stringify({ 'locked': true }));
	                                        lpUsersAuthentication.logOut();
	                                        return true;
	                                    } else {
	                                        errormsg = "generic";
	                                    }
	                                } else if (metroUiHandler.getKeyValue("login_cross_session_id") && metroUiHandler.getKeyValue("softokenError")) {
	                                    errormsg = "incorrect";
	                                }

	                                var errArray = null;
	                                errArray = metroTransmit.handleError(errormsg);
	                                $scope.endProcess(null, errArray);
	                            } else {
	                                var _errArray = null;
	                                _errArray = metroTransmit.handleError('generic');
	                                $scope.endProcess(null, _errArray);
	                            }
	                        });
	                    }
	                });

	                $scope.$watch('startregistration', function (newValue) {
	                    $scope.registrationButtonText = $scope.request && $scope.request.business_flow == "HRP" || $scope.request && $scope.request.sub_flow_type1 == "password-update" ? "Continue" : "Continue to Payment";
	                    if (newValue) {
	                        metroUiHandler.setJourney('soft_token_registration');
	                        $scope.cancelProcess();
	                        $scope.showPaymentModal = false;
	                        $scope.RegistrationStep = 0;
	                        $scope.showRegistrationModel = true;
	                        $timeout(function () {
	                            $scope.RegistrationStep = 0;
	                            $scope.startSoftTokenProcess();
	                        }, 3000);

	                        if (!$scope.$$phase) {
	                            $scope.$apply();
	                        }
	                    }
	                });

	                var scenario = {
	                    "hard_token_form": {
	                        fields: ['htoken']
	                    },
	                    "COB_SCA_HT_form": {
	                        fields: ['pwd', 'htoken']
	                    },
	                    "COB_SCA_ST_form": {
	                        fields: ['pwd', 'stoken']
	                    },
	                    "COB_SCA_ST_PW_form": {
	                        fields: ['stoken']
	                    },
	                    "hrp_cob_soft_token_password_form": {
	                        fields: ['pwd', 'stoken']
	                    }
	                };
	                $scope.decimalfy = function () {
	                    $scope.display_amt = angular.copy($scope.request.payment_amount) + '';
	                    $scope.display_device_sec = '';
	                    var splitnumber = $scope.display_amt.toString().split('.');
	                    if (splitnumber.length == 1 && splitnumber[0] > 0) {
	                        $scope.display_device_sec = splitnumber[0] + "00";
	                        $scope.display_amt = splitnumber[0] + ".00";
	                    } else if (splitnumber.length == 2 && splitnumber[0] > 0 && splitnumber[1].toString().length == 1) {
	                        $scope.display_device_sec = $scope.display_amt + "0";
	                        $scope.display_amt = $scope.display_amt.toString() + "0";
	                    } else if (splitnumber.length == 2 && splitnumber[0] == 0 && splitnumber[1].toString().length == 1) {
	                        $scope.display_device_sec = splitnumber[1] + "0";
	                        $scope.display_amt = $scope.display_amt.toString() + "0";
	                    } else if (splitnumber.length == 2 && splitnumber[0] == 0 && splitnumber[1].toString().length == 2) {
	                        if (splitnumber[1].toString().indexOf('0') == 0) {
	                            $scope.display_device_sec = splitnumber[1].substring(1);
	                        } else {
	                            $scope.display_device_sec = splitnumber[1];
	                        }
	                        $scope.display_amt = $scope.display_amt;
	                    } else {
	                        $scope.display_device_sec = splitnumber.join("");
	                        $scope.display_amt = $scope.display_amt;
	                    }
	                };

	                /* softoken  registration app */
	                $scope.cancelMobileApproval = function () {
	                    if (!$scope.fakeSoftTokenForm) {
	                        var controlRequest = com.ts.mobile.sdk.ControlRequest.create(com.ts.mobile.sdk.ControlRequestType.SelectMethod);
	                        if ($scope.resolveCancelMobileApproval) {
	                            $scope.resolveCancelMobileApproval(com.ts.mobile.sdk.InputOrControlResponse.createControlResponse(controlRequest));
	                        }
	                    } else {
	                        $scope.showTotpInput = true;
	                        $scope.hrp.stoken = "";
	                    }
	                };

	                $scope.downloadapp = function (market, storeText) {
	                    $scope.srcPath = "data:image/jpeg;base64," + $scope.QRObject[market + "_app_qr"];
	                    $scope.storeName = storeText;
	                    $scope.RegistrationStep = 2;
	                };

	                $scope.cancel = function () {
	                    $scope.RegistrationStep = 1;
	                };

	                $scope.startRegistrationProcess = function () {
	                    $scope.startregistration = true;
	                };

	                $scope.startAuthenticate = function (neverShow) {
	                    var obj = {
	                        "provision_mobile_auth_reg": true
	                    };

	                    if (neverShow) {
	                        obj = {
	                            "never_promote": true
	                        };
	                    }

	                    metroUiHandler.resolvePromise('soft_token_registration', obj);
	                };

	                $scope.startSoftToken = function () {
	                    $scope.startSoftTokenProcess();
	                };

	                $scope.softokenFailureLoginResponse = function () {
	                    var session = metroContext.getSession();
	                    var stepUpRequest = { "login_cross_session_id": metroUiHandler.getKeyValue("login_cross_session_id"), "id": session.username

	                        //console.log(stepUpRequest)
	                    };metroTransmit.invokeAnonymousPolicy("get_loggin_fail_rule_response", stepUpRequest, null).then(function (res) {
	                        alert("sucess");
	                    }).catch(function (err) {
	                        $scope.loading = false;
	                        var error = err._data;
	                        var errArray = null;
	                        var errormsg = "generic";
	                        if (error && error.failure_data && error.failure_data.reason && error.failure_data.reason.data) {
	                            if (error.failure_data.reason.data.incorrect_attempt || error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL") {
	                                errormsg = "incorrect";
	                            }
	                            if (error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING") {
	                                errormsg = "oneattemptleft";
	                            }
	                            if (error.failure_data.reason.data.account_locked || error.failure_data.reason.data.errors[0].id == "LOGIN_FAILURE_LOCKED_OUT") {
	                                window.sessionStorage.setItem('qParams', JSON.stringify({ 'locked': true }));
	                                lpUsersAuthentication.logOut();
	                                return true;
	                            }
	                        }
	                        errArray = metroTransmit.handleError(errormsg);
	                        $scope.endProcess(null, errArray);
	                    });
	                };

	                $scope.startSoftTokenProcess = function () {
	                    metroTransmit.invokePolicy("cob_enroll_mobile_authenticator", null, null).then(function (res) {
	                        $scope.startjourney = false;
	                        $scope.showPaymentModal = false;
	                        $scope.cancelMobileApproval();
	                        $scope.startregistration = false;
	                        $scope.RegistrationStep = "";
	                        $scope.showRegistrationModel = false;
	                        for (var element = 0; element < scenario[currentScenario].fields.length; element++) {
	                            $scope['show' + scenario[currentScenario].fields[element]] = false;
	                            if ($scope.hrp) {
	                                $scope.hrp[scenario[currentScenario].fields[element]] = '';
	                            }
	                        }
	                        $scope.isSoftokenJourney = true;
	                        if (!$scope.$$phase) {
	                            $scope.$apply();
	                        }
	                    }).catch(function (err) {
	                        $scope.cancelProcess('registration');
	                        console.log("Error in Registration");
	                    });
	                };

	                /* softoken  registration app */

	                $scope.startProcess = function () {
	                    $scope.isSoftokenJourney = false;
	                    $scope.showstoken = false;
	                    $scope.showTotpInput = false;

	                    var _loop = function _loop(form) {
	                        lpCoreBus.unsubscribe('user_hrp_journey.uiHandler.' + forms[form]);
	                        lpCoreBus.subscribe('user_hrp_journey.uiHandler.' + forms[form], function (obj) {
	                            window.ga('send', 'pageview', forms[form]);

	                            if (obj && obj.softToken) {
	                                $scope.isSoftokenJourney = true;
	                                $scope.showTotpInput = false;

	                                $scope.resolveCancelMobileApproval = obj.promiseResolve;
	                                $scope.endAuthenticatorSession = obj.endSession;
	                            }
	                            if (obj && obj.lastFourDigits) {
	                                $scope.ibanlastFourDigits = obj.lastFourDigits;
	                            }

	                            currentScenario = forms[form];

	                            if (currentScenario == "hrp_cob_soft_token_password_form") {
	                                $scope.softokenPasswordJourney = true;
	                            }

	                            for (var element = 0; element < scenario[currentScenario].fields.length; element++) {
	                                $scope['show' + scenario[currentScenario].fields[element]] = true;
	                                if ($scope.hrp) {
	                                    $scope.hrp[scenario[currentScenario].fields[element]] = '';
	                                }
	                            }

	                            if ($scope.request.isScaCards) {
	                                $scope.showPaymentModal = true;
	                                lpCoreBus.publish('hide-cards-modal');
	                            }

	                            $scope.formLoad = true;
	                            if (!$scope.$$phase) {
	                                $scope.$apply();
	                            }
	                        });
	                    };

	                    for (var form = 0; form < forms.length; form++) {
	                        _loop(form);
	                    }
	                    if (!$scope.request.isScaCards) {
	                        $scope.showPaymentModal = true;
	                    }
	                    $scope.showPaymentModal = true;
	                    $scope.formLoad = false;
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                };

	                lpCoreBus.subscribe('user_payment_journey.uiHandler.showQRcode', function (QrImage) {
	                    $scope.totpQRImage = "data:image/jpeg;base64," + QrImage;
	                });

	                lpCoreBus.subscribe('softoken-declined', function () {
	                    $scope.softokenDeclined = true;
	                });

	                $scope.contentSoftotokeUIHandler = function (isBioDisabled) {
	                    $scope.isBiomatricDisabled = isBioDisabled;
	                };

	                lpCoreBus.subscribe('contentSoftotokeUIHandler', function (isBioDisabled) {
	                    $scope.contentSoftotokeUIHandler(isBioDisabled);
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                });

	                lpCoreBus.subscribe('user_hrp_journey.uiHandler.hard_token_form', function () {
	                    currentScenario = 'hard_token_form';
	                    $scope.startProcess();
	                    $scope.showhtoken = true;
	                    if ($scope.hrp) {
	                        $scope.hrp.htoken = '';
	                    }
	                    $scope.formLoad = true;
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                });

	                lpCoreBus.subscribe('scaEnabled', function (flag) {
	                    $scope.disabledSoftoken = flag;
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                });

	                lpCoreBus.subscribe('user_hrp_journey.uiHandler.COB_SCA_ST_PW_form', function (obj) {
	                    if (obj && obj.softToken) {
	                        $scope.isSoftokenJourney = true;
	                        $scope.showTotpInput = false;
	                        $scope.resolveCancelMobileApproval = obj.promiseResolve;
	                        $scope.endAuthenticatorSession = obj.endSession;
	                    }

	                    $scope.isSoftokenJourney = true;
	                    currentScenario = "COB_SCA_ST_PW_form";
	                    for (var element = 0; element < scenario[currentScenario].fields.length; element++) {
	                        $scope['show' + scenario[currentScenario].fields[element]] = true;
	                        if ($scope.hrp) {
	                            $scope.hrp[scenario[currentScenario].fields[element]] = '';
	                        }
	                    }
	                    $scope.showPaymentModal = true;
	                    $scope.formLoad = true;
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                });

	                lpCoreBus.subscribe('soft_token_registration.uiHandler.cob_mobile_auth_registration_form', function (payload) {
	                    $scope.RegistrationStep = 1;
	                    $scope.stopLoader = true;
	                    $scope.QRObject = payload;
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                });

	                lpCoreBus.subscribe('user_hrp_journey.uiHandler.showTotp', function (resolve) {
	                    $scope.showTotpInput = true;
	                    $scope.showpwd = false;
	                    $scope.isSoftokenJourney = true;
	                    $scope.hrp.stoken = "";
	                    resolveSoftTokenPromise = resolve;
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                });

	                lpCoreBus.subscribe('loadTickeUi', function (ticketWaitInfo) {
	                    $scope.ticketWaitInfo = ticketWaitInfo;
	                    $scope.loadTicketInfoToUi();
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                });

	                $scope.loadTicketInfoToUi = function () {
	                    $scope.RegistrationStep = 3;
	                    if ($scope.ticketWaitInfo) {
	                        if ($scope.ticketWaitInfo.getTicketId()) {
	                            try {
	                                switch ($scope.ticketWaitInfo.getTicketId().getFormat()) {
	                                    case com.ts.mobile.sdk.TicketIdFormat.Alphanumeric:
	                                        console.log("alphanumeric");
	                                        break;
	                                    case com.ts.mobile.sdk.TicketIdFormat.Qr:
	                                        $scope.QRmapImage = "data:image/jpeg;base64," + $scope.ticketWaitInfo.getTicketId().getValue();
	                                        break;
	                                    default:
	                                }
	                            } catch (e) {
	                                this.common.log("Error in loadTicketInfoToUi(), not displaying ticket : " + e);
	                            }
	                        }
	                    }
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                };

	                $scope.submitForm = function () {

	                    $scope.messages = "";
	                    /* GA Tagging COB-SCA-BA007*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, $scope.modalHeader.toLowerCase() + ": next", metroMeta.EVENT.buttonAction);

	                    $scope.loading = true;
	                    if ($scope.hrp && !$scope.isSoftokenJourney) {
	                        if (currentScenario === 'hard_token_form') {
	                            metroUiHandler.resolvePromise('user_hrp_journey', {
	                                hardtoken: $scope.hrp.htoken
	                            });
	                        }
	                        if (currentScenario === 'COB_SCA_HT_form') {
	                            metroUiHandler.resolvePromise('user_hrp_journey', {
	                                hardtoken: $scope.hrp.htoken,
	                                password: $scope.hrp.pwd
	                            });
	                        }
	                        if (currentScenario === 'hrp_cob_soft_token_password_form') {
	                            $scope.loading = false;
	                            metroUiHandler.resolvePromise('user_hrp_journey', {
	                                password: $scope.hrp.pwd
	                            });
	                        }
	                    } else if ($scope.isSoftokenJourney) {
	                        $scope.validateSoftToken();
	                    }
	                };

	                $scope.validateSoftToken = function () {
	                    //TO DO  promise resolve is not correct
	                    if ($scope.fakeSoftTokenForm) {
	                        var obj = {
	                            totp: $scope.customer.passcode
	                        };
	                        var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(obj);
	                        metroUiHandler.resolvePromise(formInput);
	                    } else {
	                        var codeSubmission = com.ts.mobile.sdk.impl.TotpInputCodeSubmissionImpl.createTotpCodeSubmission($scope.hrp.stoken);
	                        var targetAuthInput = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(codeSubmission);
	                        resolveSoftTokenPromise.resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(targetAuthInput));
	                    }
	                };

	                $scope.cancelProcess = function (startregistration) {
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, $scope.modalHeader.toLowerCase() + ": cancel", metroMeta.EVENT.buttonAction);

	                    if ($scope.isBiomatricDisabled && $scope.request.isScaCards) {
	                        $scope.endProcess($scope.startregistration ? 'registration' : 'cancel', null, null);
	                        $scope.RegistrationStep = "";
	                        $scope.showRegistrationModel = false;
	                        $scope.isBiomatricDisabled = false;
	                    } else {
	                        metroTransmit.reinitialize().then(function () {
	                            $scope.startjourney = false;
	                            $scope.showPaymentModal = false;
	                            $scope.cancelMobileApproval();
	                            //  $scope.canceljourney();
	                            if (startregistration) {
	                                $scope.startregistration = false;
	                                $scope.RegistrationStep = "";
	                                $scope.showRegistrationModel = false;
	                                $scope.isBiomatricDisabled = false;
	                            }
	                            if ($scope.request.isScaCards) {
	                                $scope.endProcess($scope.startregistration ? 'registration' : 'cancel', null, null);
	                            }
	                            if (!$scope.$$phase) {
	                                $scope.$apply();
	                            }
	                        });
	                    }
	                };

	                var hrpjourney = function hrpjourney() {
	                    metroTransmit.invokePolicy('user_hrp_journey', { 'hrp_data_json': hrpDataRequest }, null).then(function (response) {
	                        $scope.loading = false;
	                        $scope.endProcess(response._token, null);
	                    }).catch(function (err) {
	                        // Password incorrect then only below if block need to works
	                        if (metroUiHandler.getKeyValue("softokenErrorMessage")) {
	                            errSoftokenFailure = metroUiHandler.getKeyValue("softokenErrorMessage");
	                        }

	                        if (err && err._data && err._data.failure_data && err._data.failure_data.reason && err._data.failure_data.reason.data && err._data.failure_data.reason.data.is_biometric_enabled == false) {
	                            $scope.showTotpInput = false;
	                            $scope.isBiomatricDisabled = true;
	                            $scope.isSoftokenJourney = true;
	                            $scope.showstoken = true;
	                            if (!$scope.$$phase) {
	                                $scope.$apply();
	                            }
	                        }
	                        // Password correct and have TOTP then only below if block need to works
	                        if (!$scope.softokenDeclined && !errSoftokenFailure && (metroUiHandler.getKeyValue("login_cross_session_id") || metroUiHandler.getKeyValue("softokenError"))) {
	                            if (!$scope.biomatricDisabled) {
	                                $scope.softokenFailureLoginResponse();
	                            } else {
	                                var errormsg = "generic";
	                                var errArray = metroTransmit.handleError(errormsg);
	                                $scope.loading = false;
	                                $scope.startjourney = false;
	                                $scope.showPaymentModal = false;
	                                if (!$scope.$$phase) {
	                                    $scope.$apply();
	                                }
	                                $scope.endjourneyfirst({ jwt: null, error: errArray });
	                            }
	                        } else {
	                            $scope.loading = false;
	                            var error = err._data;
	                            var _errArray2 = null;
	                            var _errormsg = "generic";
	                            if (error && error.failure_data && error.failure_data.reason && error.failure_data.reason.data || errSoftokenFailure) {
	                                console.log("inner if condition");
	                                if (error.failure_data && error.failure_data.reason.data && (error.failure_data.reason.data && error.failure_data.reason.data.incorrect_attempt || error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL") || errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ATTEMPT_FAIL") {
	                                    _errormsg = "incorrect";
	                                }
	                                if (error.failure_data && error.failure_data.reason.data && error.failure_data.reason.data.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING" || errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_TRANSMIT_ONE_ATTEMPT_REMANING") {
	                                    _errormsg = "oneattemptleft";
	                                }
	                                if (error.failure_data && error.failure_data.reason.data && (error.failure_data.reason.data.account_locked || error.failure_data.reason.data.errors[0].id == "LOGIN_FAILURE_LOCKED_OUT") || errSoftokenFailure && errSoftokenFailure.errors[0].id == "LOGIN_FAILURE_LOCKED_OUT") {
	                                    window.sessionStorage.setItem('qParams', JSON.stringify({ 'locked': true }));
	                                    lpUsersAuthentication.logOut();
	                                    return true;
	                                }
	                            } else if (metroUiHandler.getKeyValue("login_cross_session_id") && metroUiHandler.getKeyValue("softokenError")) {
	                                _errormsg = "incorrect";
	                            }
	                            _errArray2 = metroTransmit.handleError(_errormsg);
	                            $scope.endProcess(null, _errArray2);
	                        }
	                    });
	                };

	                $scope.eventtracker = function (eventvalue) {
	                    /* Card approve journey  COB-SCA-N001 && ID : COB-SCA-N002*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.textentry, metroMeta.EVENTACTION.sca, $scope.modalHeader.toLowerCase() + ":" + eventvalue, metroMeta.EVENT.textentry);
	                };

	                $scope.endProcess = function (jwtvalue, error, updatePassword) {
	                    //updatePassword
	                    $scope.loading = false;
	                    if ($scope.request.isScaCards && error && error[0].responseCode !== "LOGIN_GENERIC") {
	                        $scope.messages = error;
	                        $scope.showstoken = false;
	                        $scope.showTotpInput = false;
	                        $scope.startProcess();
	                        /* Card approve journey  COB-SCA-N001 */
	                        metroTagging.onEventTag(metroMeta.EVENTNAME.notification, metroMeta.EVENTACTION.popup, $scope.modalHeader.toLowerCase() + ": check details and try again", metroMeta.EVENT.notification);

	                        hrpjourney();
	                        if (!$scope.$$phase) {
	                            $scope.$apply();
	                        }
	                    } else {

	                        if ($scope.endAuthenticatorSession) {
	                            $scope.endAuthenticatorSession();
	                        }
	                        $scope.cancelMobileApproval();
	                        $scope.startjourney = false;
	                        $scope.showPaymentModal = false;
	                        if (!$scope.$$phase) {
	                            $scope.$apply();
	                        }
	                        $scope.endjourneyfirst({ jwt: jwtvalue, error: error, isPasswordUpdate: updatePassword });
	                    }
	                };
	                lpCoreBus.subscribe('cancel-sca-journey-international-page', function () {
	                    $scope.cancelProcess();
	                });
	            },
	            templateUrl: TEMPLATE_PATH + 'metScaPayment.html'
	        };
	    };

	    exports.metOnlyNumber = function () {
	        return {
	            restrict: 'A',
	            require: '?ngModel',
	            link: function link(scope, element, attrs, ngModelCtrl) {
	                if (!ngModelCtrl) {
	                    return;
	                }

	                ngModelCtrl.$parsers.push(function (val) {
	                    if (!val) return '';

	                    var clean = val.replace(/\D+/g, '');
	                    if (val !== clean) {
	                        ngModelCtrl.$setViewValue(clean);
	                        ngModelCtrl.$render();
	                    }
	                    return clean;
	                });
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var sdkinit = __webpack_require__(25);
	    // @ngInject
	    exports.metCard = function (TEMPLATE_PATH) {
	        return {
	            restrict: 'E',
	            scope: {
	                startjourney: '=?startjourney',
	                request: '=?request',
	                submit: '&submit'
	            },

	            controller: /* @ngInject */function controller($scope, $timeout, $element, $log, metroTransmit, metroUiHandler, lpCoreBus, lpUsersAuthentication, metroContext, metroTagging, metroMeta) {

	                $scope.showPaymentModal = true;
	                $scope.currentStep = "step1";
	                $scope.lastpayment = false;
	                $scope.secondaryUser = false;
	                $scope.isItemMgmt = false;
	                $scope.confirmLoading = false;

	                $scope.cancelStepUp = function (isCancel) {

	                    /* GA Tagging COB-SCA-BA005*/
	                    if ($scope.type) {
	                        metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, isCancel ? 'cancel authorisations: yes cancel request' : eventDetailString($scope.isItemMgmt ? 'Item management' : 'accounts', $scope.type), metroMeta.EVENT.buttonAction);
	                    }

	                    if (isCancel || $scope.lastpayment) {
	                        window.localStorage.setItem('cards_sca_modal', 'true');
	                    }
	                    $scope.show = false;
	                    $scope.currentStep = 'step1';
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                };

	                $scope.endStepUp = function (jwt, error) {
	                    if (jwt == "registration") {
	                        return true;
	                    }
	                    $scope.show = true;
	                    if (jwt === 'cancel') {
	                        $scope.stepUpObject.startjourney = false;
	                        $scope.show = true;
	                        $scope.currentStep = 'step1';
	                        if (!$scope.$$phase) {
	                            $scope.$apply();
	                        }
	                    } else {
	                        if (!error) {
	                            /* Card approve journey  COB-SCA-G004*/
	                            metroTagging.onEventTag(metroMeta.EVENTNAME.goal, $scope.type == "PA" ? metroMeta.TRANSMIT.CARDS.CONFIRMACTIONWITHAPPROVAL : metroMeta.TRANSMIT.CARDS.CONFIRMACTIONWITHCARDAPPROVAL, metroMeta.TRANSMIT.SCA.CARDAPPROVALJOURNEYCOMPLETEDDETAIL, metroMeta.EVENT.goal);

	                            startTransmitJourney('transaction_accept_decline', {
	                                "authenticationId": $scope.transactions[$scope.currentTransaction].transaction.authenticationId,
	                                "authenticationResult": "Success",
	                                "requestId": $scope.transactions[$scope.currentTransaction].requestID
	                            });
	                        } else {
	                            $scope.show = true;
	                            $scope.confirmLoading = false;
	                            if (error && error[0].responseCode === "LOGIN_GENERIC") {
	                                displayError('cardsgeneric_' + $scope.type);
	                            } else {
	                                displayError(error);
	                            }
	                        }
	                    }
	                };

	                $scope.stepUpObject = {
	                    startjourney: false,
	                    request: {},
	                    endjourneyfirst: $scope.endStepUp
	                };

	                $scope.typeOnAmount = function (type, amt) {
	                    if (type === 'NPA') {
	                        if (amt + '' === '0' || amt === '0.00' || amt === 0.00) {
	                            return 'NPA';
	                        } else {
	                            return 'PA';
	                        }
	                    } else {
	                        return 'PA';
	                    }
	                };

	                $scope.setHeader = function (type) {
	                    $scope.type = type;
	                    if (type == "PA") {
	                        $scope.modalHeader = "Authorise online payments";
	                    } else {
	                        $scope.modalHeader = "Authorise your card";
	                    }
	                };

	                $scope.needHelp = function () {
	                    /* GA Tagging COB-SCA-BA005*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, $scope.modalHeader.toLowerCase() + ": help", metroMeta.EVENT.buttonAction);

	                    $scope.toggleHelp = !$scope.toggleHelp;
	                };

	                $scope.setSubtitle = function () {
	                    var paymenttypes = {};
	                    if ($scope.transactions.length > 0) {
	                        for (var i = 0; i < $scope.transactions.length; i++) {
	                            var type = $scope.typeOnAmount($scope.transactions[i].authentication.type, $scope.transactions[i].transaction.amount);
	                            paymenttypes[type] = paymenttypes[type] == undefined ? 1 : parseInt(paymenttypes[type]) + 1;
	                        }

	                        if (paymenttypes.PA && paymenttypes.PA > 0 && paymenttypes.NPA && paymenttypes.NPA > 0) {
	                            $scope.subtitle = "Authorisation";
	                        } else if (paymenttypes.PA && paymenttypes.PA > 0) {
	                            $scope.subtitle = "Payment";
	                        } else if (paymenttypes.NPA && paymenttypes.NPA > 0) {
	                            $scope.subtitle = "Authorisation";
	                        } else {
	                            $scope.subtitle = "";
	                        }
	                    }
	                };

	                var showApproved = function showApproved() {
	                    $scope.show = true;
	                    $scope.messages = null;

	                    if ($scope.type === "NPA") {
	                        $scope.cardStatus = {
	                            message: "Approved",
	                            header: "Approved card addition - what to do next",
	                            description: "Please return to the seller's website to complete adding your card."
	                        };
	                    } else {
	                        $scope.cardStatus = {
	                            message: "Approved",
	                            header: "Approved payment - what to do next",
	                            description: "Please return to the seller's website to complete your approved payment."
	                        };
	                    }
	                    /* Card approve journey  COB-SCA-G005*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.goal, $scope.modalHeader.toLowerCase() + ": approval", metroMeta.TRANSMIT.CARDS.JOURNEYCOMPLETEDWITHRESULTDETAIL, metroMeta.EVENT.goal);
	                    $scope.currentStep = 'step2';
	                    $scope.modalHeader = "Thank you, almost there!";

	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                };

	                var showDeclined = function showDeclined() {
	                    $scope.show = true;

	                    $scope.messages = null;
	                    if ($scope.type === "PA") {
	                        $scope.cardStatus = {
	                            message: "Declined",
	                            header: "Declined payment - what to do next",
	                            description: "If you don't recognise this payment, please contact us immediately on the details below. If you declined a payment by mistake, you can now return to seller's website and make the payment again."
	                        };
	                    } else {
	                        $scope.cardStatus = {
	                            message: "Declined",
	                            header: "Declined card addition - what to do next",
	                            description: "If you didn’t make this request, please contact us straightaway on the details below. If you declined it by mistake, please return to the seller’s website and add the card again."
	                        };
	                    }

	                    /* Card approve journey  COB-SCA-G009*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.goal, $scope.modalHeader.toLowerCase() + ": decline", metroMeta.TRANSMIT.CARDS.JOURNEYCOMPLETEDWITHRESULTDETAIL, metroMeta.EVENT.goal);

	                    $scope.modalHeader = "Thank you, almost there!";
	                    $scope.currentStep = 'step2';

	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                };

	                $scope.transactions = [];
	                $scope.currentTransaction;
	                var startTransmitJourney = function startTransmitJourney(journey, object) {
	                    metroTransmit.invokePolicy(journey, object, null).then(function (response) {
	                        if (journey === "retrieve_transactions_cob") {
	                            if (response._internalData.json_data && response._internalData.json_data && response._internalData.json_data.authentications && response._internalData.json_data.authentications.length > 0) {

	                                $scope.show = true;
	                                $scope.transactions = response._internalData.json_data.authentications;
	                                $scope.setSubtitle();
	                                $scope.currentTransaction = 0;
	                                $scope.lastpayment = $scope.currentTransaction + 1 === $scope.transactions.length;

	                                $scope.setHeader($scope.typeOnAmount($scope.transactions[$scope.currentTransaction].authentication.type, $scope.transactions[$scope.currentTransaction].transaction.amount));
	                                if (!$scope.$$phase) {
	                                    $scope.$apply();
	                                }
	                                metroTagging.onpageLoadTag('Card Ecommerce | Metrobank', document.location.pathname + "/modal-ecommerce-card/" + ($scope.type == 'PA' ? 'payment' : 'card'), metroMeta.EVENT.pageLoaded);

	                                /* Card approve journey  COB-SCA-G001*/
	                                metroTagging.onEventTag(metroMeta.EVENTNAME.goal, $scope.modalHeader.toLowerCase(), metroMeta.TRANSMIT.CARDS.JOURNEYSTARTEVENTDETAIL, metroMeta.EVENT.goal);
	                            } else {
	                                if (response._internalData.json_data && response._internalData.json_data.length === 0) {
	                                    $scope.cancelStepUp();
	                                    window.localStorage.setItem('cards_sca_modal', 'true');
	                                }
	                            }
	                        }

	                        if (journey === "transaction_accept_decline") {
	                            if (response._internalData.json_data && response._internalData.json_data.data) {
	                                $scope.confirmLoading = false;
	                                $scope.lastpayment = $scope.currentTransaction + 1 === $scope.transactions.length;
	                                if (response._internalData.json_data.data.transaction_action_successful) {
	                                    if (object.authenticationResult === "Success") {
	                                        showApproved();
	                                    } else {
	                                        showDeclined();
	                                    }
	                                } else {
	                                    displayHighrisk();
	                                }

	                                metroTagging.onpageLoadTag('Card Ecommerce | Metrobank', document.location.pathname + "/modal-ecommerce-card/" + (object.authenticationResult == "Success" && response._internalData.json_data.data.transaction_action_successful ? 'approved-' : 'declined-') + ($scope.type === "PA" ? 'payment' : 'card') + "/thankyou", metroMeta.EVENT.pageLoaded);

	                                if (!$scope.$$phase) {
	                                    $scope.$apply();
	                                }
	                            }
	                        }
	                    }).catch(function (err) {
	                        console.log(err);
	                        var error = err._data;
	                        $scope.confirmLoading = false;

	                        if (error && error.failure_data && error.failure_data.reason) {
	                            displayError('tysys_failure_' + $scope.type);
	                            $scope.isTysysError = true;
	                            if (!$scope.$$phase) {
	                                $scope.$apply();
	                            }
	                        } else {
	                            displayError('cardsgeneric_' + $scope.type);
	                        }

	                        /* Card approve journey  COB-SCA-N001*/
	                        metroTagging.onEventTag(metroMeta.EVENTNAME.notification, metroMeta.EVENTACTION.popup, ($scope.modalHeader ? $scope.modalHeader.toLowerCase() : 'card stepup journey') + ": somethings wrong try again", metroMeta.EVENT.notification);
	                    });
	                };

	                var displayHighrisk = function displayHighrisk() {
	                    $scope.approvalFlag = 'Declined';
	                    $scope.isHighRisk = true;
	                    $scope.type = $scope.typeOnAmount($scope.transactions[$scope.currentTransaction].authentication.type, $scope.transactions[$scope.currentTransaction].transaction.amount);
	                    if ($scope.type === "NPA") {
	                        $scope.cardStatus = {
	                            message: "Declined",
	                            header: "Your card addition has been declined",
	                            description: "To keep you safe we've had to decline this request"
	                        };
	                    } else {
	                        $scope.cardStatus = {
	                            message: "Declined",
	                            header: "Your transaction has been declined",
	                            description: "To keep you safe we've had to decline this payment"
	                        };
	                    }
	                    $scope.currentStep = 'step2';
	                    $scope.messages = metroTransmit.handleError('transmit_high_risk');
	                    $scope.modalHeader = null;
	                    $scope.focusTop('errortemp');

	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                };

	                $scope.$watch('startjourney', function (newValue) {
	                    if (newValue) {
	                        startTransmitJourney("retrieve_transactions_cob", {}, null);
	                        $scope.isItemMgmt = window.location.href.indexOf('item-management') >= 0 ? true : false;
	                        //$scope.secondaryUser = true;
	                        //lpCoreBus.publish('secondary-user');
	                    }
	                });

	                $scope.submitForm = function () {

	                    /* GA Tagging COB-SCA-BA004*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, $scope.modalHeader.toLowerCase() + ": confirm payment", metroMeta.EVENT.buttonAction);

	                    if ($scope.approvalFlag) {
	                        $scope.confirmLoading = true;
	                        if ($scope.approvalFlag === 'Declined') {
	                            startTransmitJourney('transaction_accept_decline', {
	                                "authenticationId": $scope.transactions[$scope.currentTransaction].transaction.authenticationId,
	                                "authenticationResult": "UserCanceled",
	                                "requestId": $scope.transactions[$scope.currentTransaction].requestID
	                            });

	                            /* Card approve journey  COB-SCA-G006*/
	                            metroTagging.onEventTag(metroMeta.EVENTNAME.goal, $scope.modalHeader.toLowerCase() + ": decline", metroMeta.TRANSMIT.CARDS.JOURNEYCOMPLETEDDETAIL, metroMeta.EVENT.goal);
	                        } else {
	                            $scope.stepUpObject.request = {
	                                "business_flow": 'card',
	                                "sub_flow_type1": 'transaction',
	                                "sub_flow_type2": $scope.transactions[$scope.currentTransaction].authentication.type,
	                                "sub_flow_type3": '',
	                                "customer_operation": 'approve',
	                                'ben_account_number': '', //card number
	                                'payment_amount': '',
	                                "payment_ccy": '',
	                                "authenticationId": $scope.transactions[$scope.currentTransaction].transaction.authenticationId,
	                                'payment_id': '',
	                                'trusted_ben': '',
	                                'requestId': $scope.transactions[$scope.currentTransaction].requestID,
	                                "authenticationResult": "Success",
	                                'isScaCards': true,
	                                'isPA': $scope.type === 'PA',
	                                "isMultipleTransaction": $scope.transactions.length > $scope.currentTransaction + 1
	                                /* Card approve journey  COB-SCA-G002*/
	                            };metroTagging.onEventTag(metroMeta.EVENTNAME.goal, $scope.modalHeader.toLowerCase() + ": approval", metroMeta.TRANSMIT.CARDS.JOURNEYCOMPLETEDDETAIL, metroMeta.EVENT.goal);

	                            lpCoreBus.subscribe('hide-cards-modal', function () {
	                                $scope.confirmLoading = false;
	                                $scope.show = false;
	                                if (!$scope.$$phase) {
	                                    $scope.$apply();
	                                }
	                            });
	                            $scope.stepUpObject.startjourney = true;
	                        }
	                    } else {
	                        displayError('approvalunselected');
	                        /* Card approve journey  COB-SCA-N001*/
	                        metroTagging.onEventTag(metroMeta.EVENTNAME.notification, metroMeta.EVENTACTION.inline, $scope.modalHeader + ": Please select an option", metroMeta.EVENT.notification);
	                    }
	                };
	                //To do :  Retest this functionlity : Accessiblity
	                $scope.focusTop = function (focusElement) {
	                    if (document.getElementById('errortemp')) {
	                        $('.modal-content').animate({
	                            scrollTop: $('#' + focusElement).css('top')
	                        }, 800);
	                        document.getElementById('errortemp').focus();
	                    }
	                    //var customerNoElement = angular.element('.'+focusElement);
	                };

	                $scope.cancelProcess = function () {
	                    /* GA Tagging  COB-SCA-BA003*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, eventDetailCancelString("cancel"), metroMeta.EVENT.buttonAction);
	                    if ($scope.currentStep == "step2" && !$scope.lastpayment) {
	                        $scope.currentTransaction = $scope.currentTransaction + 1;
	                    }

	                    $scope.approvalFlag = "";
	                    if ($scope.messages && $scope.messages[0].responseCode != 'tysys_failure') {
	                        $scope.messages = null;
	                    }
	                    $scope.currentStep = "cancelTransactions";
	                    $scope.modalHeader = "Cancel authorisations";

	                    metroTagging.onpageLoadTag('Card Ecommerce | Metrobank', document.location.pathname + "/modal-ecommerce-card/" + ($scope.type == 'PA' ? 'payment' : 'card') + "/cancel", metroMeta.EVENT.pageLoaded);
	                };

	                $scope.logout = function () {
	                    /* GA Tagging COB-SCA-BA009*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, eventDetailString('log out', $scope.type), metroMeta.EVENT.buttonAction);

	                    lpUsersAuthentication.logOut();
	                };

	                var eventDetailString = function eventDetailString(value, trasactionType) {
	                    var eventDetail;
	                    if ($scope.approvalFlag == 'Declined' && trasactionType == 'PA') {
	                        eventDetail = metroMeta.TRANSMIT.CARDS.DECLINEDPAYMENT + ": " + value;
	                    } else if ($scope.approvalFlag == 'Approved' && trasactionType == 'PA') {
	                        eventDetail = metroMeta.TRANSMIT.CARDS.APPROVEDPAYMENT + ": " + value;
	                    } else if ($scope.approvalFlag == 'Declined' && trasactionType == 'NPA') {
	                        eventDetail = metroMeta.TRANSMIT.CARDS.DECLINECARD + ": " + value;
	                    } else if ($scope.approvalFlag == 'Approved' && trasactionType == 'NPA') {
	                        eventDetail = metroMeta.TRANSMIT.CARDS.APPROVEDCARD + ": " + value;
	                    }
	                    return eventDetail;
	                };

	                var eventDetailCancelString = function eventDetailCancelString(value) {
	                    var eventDetail;
	                    if ($scope.currentStep == "step1" || $scope.currentStep == "cancelTransactions") {
	                        eventDetail = $scope.modalHeader.toLowerCase() + ": " + value;
	                    } else {
	                        //($scope.currentStep == "step2"
	                        console.log("console.log");
	                        eventDetail = $scope.cardStatus.header.toLowerCase().split(" - ")[0].toLowerCase() + ": " + value;
	                    }

	                    return eventDetail;
	                };

	                $scope.nextPayment = function () {

	                    $scope.messages = null;
	                    $scope.isTysysError = false;
	                    $scope.isHighRisk = false;
	                    var currentTrasactionType = angular.copy($scope.type);
	                    $scope.lastpayment = $scope.currentTransaction + 1 === $scope.transactions.length;
	                    !$scope.lastpayment ? $scope.currentTransaction = $scope.currentTransaction + 1 : '';
	                    $scope.currentStep = "step1";
	                    $scope.toggleHelp = false;
	                    $scope.setHeader($scope.typeOnAmount($scope.transactions[$scope.currentTransaction].authentication.type, $scope.transactions[$scope.currentTransaction].transaction.amount));

	                    /* GA Tagging COB-SCA-BA009 */
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, eventDetailString($scope.type == 'PA' ? 'go to next payment' : 'go to next authorisation', currentTrasactionType), metroMeta.EVENT.buttonAction);

	                    /* Card approve journey COB-SCA-G006 */
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.goal, $scope.type == "PA" ? "authorise online payments" : "authorise your card", metroMeta.TRANSMIT.CARDS.JOURNEYSTARTEVENTDETAIL, metroMeta.EVENT.goal);

	                    $scope.approvalFlag = null;
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                };

	                $scope.goBack = function () {
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, $scope.modalHeader.toLowerCase() + ": no go back", metroMeta.EVENT.buttonAction);

	                    if ($scope.approvalFlag && !$scope.lastpayment && $scope.currentStep == "step2") {
	                        $scope.nextPayment();
	                    }
	                    $scope.setHeader($scope.typeOnAmount($scope.transactions[$scope.currentTransaction].authentication.type, $scope.transactions[$scope.currentTransaction].transaction.amount));
	                    $scope.toggleHelp = false;
	                    $scope.currentStep = "step1";
	                };

	                $scope.approvalFlag = null;
	                $scope.approval = function (value) {
	                    /* GA Tagging  COB-SCA-BA001 & COB-SCA-BA002*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, $scope.modalHeader.toLowerCase() + ": " + (value == "Approved" ? 'approve' : 'decline'), metroMeta.EVENT.buttonAction);

	                    $scope.approvalFlag = value;
	                    $scope.messages = null;
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                };
	                var displayError = function displayError(errorType) {
	                    $scope.messages = metroTransmit.handleError(errorType);
	                    if (!$scope.$$phase) {
	                        $scope.$apply();
	                    }
	                    $scope.focusTop('errortemp');
	                };
	            },
	            templateUrl: TEMPLATE_PATH + 'metCard.html'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.slidingCheckbox = function () {
	        return {
	            restrict: 'E',
	            template: '<div class="custom-checkbox sliding-checkbox">' + '   <input type="checkbox" data-ng-model="checked">' + '   <label><span><span></span></span></label>' + '</div>          '
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /**
	     * Directive for drawing the customizable checkbox
	     */

	    exports.metCheckbox = function () {
	        return {
	            restrict: 'E',
	            scope: {
	                checked: '=',
	                label: '@',
	                disabled: '@'
	            },
	            replace: true,
	            link: function link(scope, element) {

	                if (!scope.checked) {
	                    scope.checked = false;
	                }

	                //the input element inside the directive
	                var myInput = element.find('input');

	                // Disables the checkbox
	                scope.$watch('disabled', function () {
	                    if (scope.disabled === 'true') {
	                        myInput.attr('disabled', 'true');
	                        element.addClass('disabled');
	                    } else {
	                        myInput.attr('disabled', null);
	                        element.removeClass('disabled');
	                    }
	                });
	            },
	            template: '<div class="custom-checkbox">' + '   <input type="checkbox" data-ng-model="checked">' + '   <label>' + '       <span><span></span></span>' + '       {{label}}' + '   </label>' + '</div>'
	        };
	    };

	    /**
	     * Directive for an indeterminate checkbox
	     */
	    exports.metIndeterminateCheckbox = function () {
	        return {
	            restrict: 'A',
	            require: '?ngModel',
	            link: function link(scope, element, attrs, ctrl) {

	                var childList = attrs.childList;
	                var disabled = attrs.disabled;
	                var myInput = element.find('input');
	                var property = 'checked';

	                // Disables the checkbox
	                if (disabled) {
	                    myInput.attr('disabled', 'true');
	                    element.addClass('disabled');
	                }

	                // Bind the onChange event to update children
	                element.bind('change', function () {
	                    scope.$apply(function () {
	                        var isChecked = myInput.prop('checked');

	                        // Set each child's selected property to the checkbox's checked property
	                        var children = scope.$eval(childList);
	                        for (var i = children.length - 1; i >= 0; i--) {
	                            var child = children[i];
	                            child[property] = isChecked;
	                        }
	                    });
	                });

	                // Watch the children for changes
	                scope.$watch(childList, function (newValue) {
	                    var hasChecked = false;
	                    var hasUnchecked = false;

	                    // Loop through the children
	                    for (var i = newValue.length - 1; i >= 0; i--) {
	                        var child = newValue[i];
	                        if (child[property]) {
	                            hasChecked = true;
	                        } else {
	                            hasUnchecked = true;
	                        }
	                    }

	                    // Determine which state to put the checkbox in
	                    if (hasChecked && hasUnchecked) {
	                        myInput.prop('checked', false);
	                        myInput.prop('indeterminate', true);
	                        if (ctrl) {
	                            ctrl.$setViewValue(false);
	                        }
	                    } else {
	                        myInput.prop('checked', hasChecked);
	                        myInput.prop('indeterminate', false);
	                        if (ctrl) {
	                            ctrl.$setViewValue(hasChecked);
	                        }
	                    }
	                }, true);
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /** @type {ng.IAngularStatic} */

	    var angular = __webpack_require__(17);

	    // The accordion directive simply sets up the directive controller
	    // and adds an accordion CSS class to itself element.
	    exports.metAccordion = function () {
	        return {
	            restrict: 'E',
	            controller: 'MetAccordionController',
	            controllerAs: 'accordion',
	            transclude: true,
	            link: function link() {},
	            template: '<div class="panel-group" ng-transclude></div>'
	        };
	    };

	    // @ngInject
	    exports.metAccordionGroup = function (metroTagging, metroMeta) {
	        return {
	            restrict: 'E',
	            require: '^metAccordion', // We need this directive to be inside an accordion
	            transclude: true,
	            replace: true, // The element containing the directive will be replaced with the template
	            link: function link(scope, element, attrs, accordionCtrl) {

	                accordionCtrl.addGroup(scope);

	                scope.openClass = attrs.openClass || 'panel-open';
	                scope.panelClass = attrs.panelClass || 'panel-met';

	                scope.$watch('isOpen', function (value) {
	                    element.toggleClass(scope.openClass, !!value);
	                    if (value) {
	                        accordionCtrl.closeOthers(scope);
	                    }
	                });

	                scope.toggleOpen = function ($event) {
	                    if (!scope.isDisabled) {
	                        if (!$event || $event.which === 32) {
	                            scope.isOpen = !scope.isOpen;
	                        }
	                    }
	                };

	                scope.signalOpened = function (obj) {

	                    /* GA Tagging COB-SCA-BA016*/
	                    metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick, metroMeta.EVENTACTION.sca, attrs.module + ":" + scope.heading, metroMeta.EVENT.buttonAction);

	                    if (scope.isOpen === true) {
	                        scope.openAction(obj, scope.index);
	                    }
	                };
	            },
	            controller: function controller() {
	                this.setHeading = function (element) {
	                    this.heading = element;
	                };
	            },
	            scope: {
	                heading: '@', // Interpolate the heading attribute onto this scope
	                icon: '@',
	                count: '@',
	                isOpen: '=?',
	                isDisabled: '=?',
	                openAction: '&',
	                showSwitcher: '@',
	                index: '=?'
	            },
	            template: '<div class="panel" ng-class="panelClass || \'panel-met\'">' + '   <div class="panel-heading" ng-keypress="toggleOpen($event)">' + '       <div class="panel-title">' + '           <div tabindex="0" class="accordion-toggle" ng-click="toggleOpen(); signalOpened(this)" met-accordion-transclude="heading">' + '               <span ng-class="{\'text-muted\': isDisabled}"><span ng-if="icon"><i class="fa fa-{{icon}}"></i></span> ' + '               <h4>{{heading}} <span class="badge badge-important" ng-show="count" ng-bind="count">  </h4></span><span ng-show="showSwitcher" class="accordion-switcher"><i class="fa" ng-class="{\'fa-caret-down fa-lg\': isOpen, \'fa-caret-right fa-lg\': !isOpen}"></i></span>' + '           </div>' + '       </div>' + '   </div>' + '   <div class="panel-collapse" ng-class="{collapse: isOpen == false}">' + '       <div class="panel-body" ng-transclude></div>' + '   </div>' + '</div>'
	        };
	    };

	    // Use accordion-heading below an accordion-group to provide a heading containing HTML
	    exports.metAccordionHeading = function () {
	        return {
	            transclude: true, // Grab the contents to be used as the heading
	            template: '', // In effect remove this element!
	            replace: true,
	            require: '^metAccordionGroup',
	            link: function link(scope, element, attrs, accordionGroupCtrl, transclude) {
	                // Pass the heading to the accordion-group controller
	                // so that it can be transcluded into the right place in the template
	                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	                accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	            }
	        };
	    };

	    // Use in the accordion-group template to indicate where you want the heading to be transcluded
	    // You must provide the property on the accordion-group controller that will hold the transcluded element
	    exports.metAccordionTransclude = function () {
	        return {
	            require: '^metAccordionGroup',
	            link: function link(scope, element, attrs, controller) {
	                scope.$watch(function () {
	                    return controller[attrs.metAccordionTransclude];
	                }, function (heading) {
	                    if (heading) {
	                        element.find('span').html('');
	                        element.find('span').append(heading);
	                    }
	                });
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 * Directive Metro Search
	 * @module Search Component
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.metListLoader = function () {
	        return {
	            restrict: 'E',
	            replace: true,
	            scope: {
	                loading: '='
	            },
	            template: '<div class="text-center" ng-show="loading"><i class="fa fa-2x fa-spinner fa-spin"></i></div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.numberDisplay = function () {
	        return {
	            restrict: 'E',
	            replace: true,
	            scope: {
	                name: '@',
	                label: '@',
	                maximum: '@',
	                model: '='
	            },
	            link: function link() {},
	            template: '<div class="fixed-input">' + '   <div class="input-background"></div>' + '   <div class="number-input" ng-show="!edit" ng-click="editMe()">{{model | number : 2}}</div>' + '   <label ng-class="{filled: model!=null}">{{label}}</label>' + '</div>'
	        };
	    };

	    // @ngInject
	    exports.numberFormat = function () {
	        return {
	            require: '?ngModel',
	            link: function link(scope, elem, attrs, ctrl) {
	                if (!ctrl) {
	                    return;
	                }
	                ctrl.$parsers.unshift(function (viewValue) {
	                    var plainNumber = viewValue.replace(/[^,\.\d]?/g, '');
	                    elem.val(plainNumber);
	                    return plainNumber;
	                });
	                //Still there is some cases each 3 key strokes a letter can stay in the inbox, probably need to apply logic with $formatters also.
	            }
	        };
	    };

	    // @ngInject
	    exports.maxValue = function () {
	        return {
	            require: '?ngModel',
	            link: function link(scope, elem, attrs) {

	                elem.bind('propertychange keyup paste', function () {
	                    if (parseFloat(elem.context.value) > parseFloat(attrs.maxValue)) {
	                        elem.parent().parent().addClass('greater');
	                    } else {
	                        elem.parent().parent().removeClass('greater');
	                    }
	                });
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 * Directives to handle input and scope.form styling and validation
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var angular = __webpack_require__(17);

	    // @ngInject
	    /**
	     * @param {ng.ILogService} $log
	     */
	    exports.metForm = function ($log) {
	        return {
	            restrict: 'A',
	            require: '?form',
	            link: function link(scope, elem, attrs, ctrl) {
	                $log.info('metForm');
	                if ('validationOnSubmit' in attrs) {
	                    ctrl.validationOnSubmit = true;
	                }
	                if ('errorMessages' in attrs) {
	                    ctrl.errorMessages = attrs.errorMessages;
	                }
	                elem.on('submit', function () {
	                    scope.$broadcast('form:submit');
	                });

	                if (attrs.changeEvent) {
	                    ctrl.changeEvent = attrs.changeEvent;
	                }
	            }
	        };
	    };

	    // @ngInject
	    exports.metInputGroup = function () {
	        return {
	            restrict: 'A',
	            controller: /* @ngInject */function controller($scope, $element) {
	                var position = 'pre';
	                var elms = $element.find('> *');
	                $element.addClass('met-input-group');

	                angular.forEach(elms, function (elm) {
	                    if (elm.localName === 'input') {
	                        this.input = elm;
	                        position = 'after';
	                    } else {
	                        this[position] = this[position] ? this[position] : [];
	                        this[position].push(elm);
	                    }
	                }.bind(this));
	            }
	        };
	    };

	    exports.metDisplayOnlyInput = function () {
	        return {
	            restrict: 'A',
	            template: ['<input', '    type="text"', '    ng-model="showValue"', '    data-label="{{label}}"', '    met-input', '    ng-disabled="true">'].join(''),
	            scope: {
	                showValue: '=',
	                label: '@'
	            }
	        };
	    };

	    // Fix for dynamic form names for angularjs < 1.3
	    exports.metDynamicName = function () {
	        return {
	            restrict: 'A',
	            priority: -1,
	            require: ['ngModel'],
	            link: function link(scope, element, attr, ngModel) {
	                ngModel[0].$name = attr.name;
	            }
	        };
	    };

	    // @ngInject
	    /**
	     * @param {ng.ICompileService} $compile
	     * @param {ng.ILogService} $log
	     */
	    exports.metInput = function ($compile, $log, lpCoreBus) {
	        return {
	            restrict: 'A',
	            require: ['ngModel', '^?form', '^?metInputGroup'],
	            scope: {
	                label: '@',
	                errorMessages: '=',
	                validationOnBlur: '&',
	                parentClass: '='
	            },
	            link: function link(scope, elem, attrs, ctrls) {

	                // Stop execution if elem is not an <input>
	                if (elem[0].localName !== 'input') {
	                    $log.error('Directive metInput: this directive must be applied to an <input> element.\n' + 'Aborting directive execution.\n' + elem[0].outerHTML);
	                    return false;
	                }

	                // Stop execution if there's no scope.ngModelCtrl directive attached to the element
	                if (!ctrls[0]) {
	                    $log.error('Directive metInput: Input field "' + (elem[0].name || 'unknown') + '" has no scope.ngModelCtrl.\n' + 'Aborting directive execution.\n' + elem[0].outerHTML);
	                    return false;
	                }

	                // scope.ngModelCtrlController and scope.formController (parent <form> element)
	                scope.ngModelCtrl = ctrls[0];
	                scope.form = ctrls[1];
	                scope.metInputGroup = ctrls[2];

	                // Alert that validation only on scope.form submission is not possible
	                // and set a variable for validationOnSubmit
	                if (!scope.form) {
	                    $log.warn('Directive metInput: Input field "' + elem[0].name + '" has no parent form controller.\n' + 'On submit validation not possible\n' + elem[0].outerHTML);
	                }

	                // Check if form has changeEvent attribute and add the event at the attribute
	                // to pubsub
	                if (scope.form) {
	                    setTimeout(function () {
	                        if (scope.form.changeEvent) {
	                            lpCoreBus.subscribe(scope.form.changeEvent, function () {
	                                // scope.ngModelCtrl.$setViewValue(scope.ngModelCtrl.$viewValue);
	                            });
	                        }
	                    }, 0);
	                }

	                scope.error = {
	                    showError: false,
	                    errorMessage: 'This is a generic error message'
	                };

	                /**
	                 * Basic Error Messages object
	                 * @type {Object}
	                 */
	                var ErrorMessages = {
	                    minlength: 'The value entered is too short',
	                    maxlength: 'The value entered is too long',
	                    pattern: 'There is an invalid character',
	                    required: 'This field is required',
	                    min: 'The value entered is below minimum',
	                    max: 'The value entered is above maximum'
	                };

	                if (scope.form) {
	                    setTimeout(function () {
	                        if (scope.form.errorMessages) {
	                            angular.forEach(JSON.parse(scope.form.errorMessages.replace(/'/g, '"')), function (value, key) {
	                                ErrorMessages[key] = value;
	                                $log.info('metInput: at Input field "' + (elem[0].name || 'unknown') + '", the error message "' + key + '"" was redefined as "' + value + '", as defined by the parent metForm directive.');
	                            });
	                        }
	                    }, 0);
	                }

	                angular.forEach(scope.errorMessages, function (value, key) {
	                    ErrorMessages[key] = value;
	                });

	                /**
	                 * Wrap the input element in divs for styling
	                 */
	                var parentClass = '';
	                if (attrs.parentClass) {
	                    parentClass = attrs.parentClass;
	                }

	                elem.addClass('form-control');

	                // If label is missing, add a class to the input element
	                if (!scope.label) {
	                    scope.label = '';
	                    elem.addClass('no-label');
	                }

	                var wrapper = $compile('<div class="metro-form-input form-group ' + parentClass + '">' + '<div class="metro-form-input-item bg-white"></div></div>')(scope);
	                elem.wrap(wrapper);

	                var asAdd = !!scope.metInputGroup && (scope.metInputGroup.pre || scope.metInputGroup.after);
	                if (asAdd) {
	                    var inputGroup = angular.element('<div class="input-group"></div>');
	                    elem.wrap(inputGroup);
	                    elem.before(scope.metInputGroup.pre);
	                    elem.after(scope.metInputGroup.after);
	                }

	                /**
	                 * Create and add the error message element
	                 */
	                var errorElem = $compile('<div ng-if="error.showError" class="help-block">{{error.errorMessage}}</div>')(scope);
	                elem.parents('.metro-form-input-item').after(errorElem);

	                /**
	                 * Create and add the vaidation icon element
	                 */
	                var iconElem = $compile('<span ng-show="ngModelCtrl.$valid && !ngModelCtrl.$pristine && displayValid" class="form-control-feedback fa" ng-class="{\'fa-check text-success\': ngModelCtrl.$valid}" aria-hidden="true"></span>')(scope);
	                elem.parents('.metro-form-input-item').after(iconElem);

	                /**
	                 * Create and add the label element
	                 */
	                var labelElem = $compile('<label>' + scope.label + '</label>')(scope);
	                elem.after(labelElem);

	                /**
	                 * Sets the proper error message
	                 *  Important: Object.keys(scope.ngModelCtrl.$error)[0]
	                 *  gets always the first error captured; to make it get
	                 *  the latest value, use [Object.keys(scope.ngModelCtrl.$error).length - 1]
	                 *  instead of [0]
	                 */
	                var setErrorMessage = function setErrorMessage() {

	                    scope.error.errorMessage = '';
	                    scope.valid = true;
	                    if (Object.keys(scope.ngModelCtrl.$error).length > 0) {
	                        angular.forEach(scope.ngModelCtrl.$error, function (value, key) {
	                            if (scope.ngModelCtrl.$error[key]) {
	                                scope.error.errorMessage = ErrorMessages[key];
	                            }
	                        });
	                        scope.valid = false;
	                    }
	                };

	                /**
	                 * To do: on submit validation
	                 * Still not working properly
	                 */
	                scope.$on('form:submit', function () {

	                    if (scope.form.validationOnSubmit) {
	                        setErrorMessage();
	                        scope.$apply(function () {
	                            scope.displayValid = true;
	                            scope.error.showError = true;
	                        });
	                        scope.form.$submitted = false;
	                    }
	                });

	                /**
	                 * Treats validation on keypress
	                 */
	                var validateOnChange = function validateOnChange() {
	                    if (elem.hasClass('isEnabled')) {
	                        setErrorMessage();
	                        scope.error.showError = false;
	                        if (!scope.ngModelCtrl.$valid && !scope.ngModelCtrl.$pristine && !('validationOnBlur' in attrs) && !scope.form.validationOnSubmit) {
	                            scope.error.showError = true;
	                        }
	                    }
	                };

	                /**
	                 * OnBlur validation
	                 */
	                elem.on('blur', function () {

	                    if ('validationOnBlur' in attrs && !scope.form.validationOnSubmit) {

	                        setErrorMessage();
	                        scope.error.showError = false;
	                        if (!scope.ngModelCtrl.$valid && !scope.ngModelCtrl.$pristine) {
	                            scope.$apply(function () {
	                                scope.error.showError = true;
	                            });
	                        }
	                    }
	                });

	                /**
	                 * On Model Value Change updates error message display
	                 */
	                scope.$watch(function () {
	                    return scope.ngModelCtrl.$modelValue;
	                }, function handleModelValueChange(newValue) {

	                    if (!newValue && scope.error.showError) {

	                        scope.error.showError = false;
	                    }
	                });

	                /**
	                 * OnChange validation
	                 */
	                scope.$watch(function () {
	                    return scope.ngModelCtrl.$viewValue;
	                }, function handleValueChange(newValue, oldValue) {
	                    if (newValue !== oldValue) {
	                        scope.ngModelCtrl.$setViewValue(scope.ngModelCtrl.$viewValue);
	                    }

	                    /**
	                     * Yeah, we know this is horrible
	                     * however it's the only way to avoid
	                     * the wrong activation!
	                     * Good luck to find another approach ;-)
	                     */
	                    setTimeout(function () {
	                        if (newValue === oldValue && oldValue !== '' && oldValue !== null && oldValue !== undefined) {
	                            scope.valid = true;
	                            scope.ngModelCtrl.$setViewValue(scope.ngModelCtrl.$viewValue);
	                        }

	                        validateOnChange();

	                        if (elem.hasClass('isEnabled')) {
	                            scope.valid = false;

	                            if (scope.ngModelCtrl.$valid) {
	                                scope.valid = true;
	                            }
	                        } else {
	                            scope.valid = true;
	                        }

	                        scope.$apply();
	                    }, 20);
	                });

	                /**
	                 * Watch for disabled property change and updates dirtyness
	                 */
	                scope.$watch(function () {
	                    return elem.prop('disabled');
	                }, function (newValue, oldValue) {
	                    if (newValue !== oldValue) {
	                        if (newValue) {
	                            elem.removeClass('isEnabled');
	                        } else {
	                            elem.addClass('isEnabled');
	                        }
	                    }
	                });

	                scope.$watch(function () {
	                    return scope.ngModelCtrl.$error;
	                }, function handleErrorChange() {
	                    setTimeout(function () {
	                        setErrorMessage();

	                        scope.error.showError = false;
	                        if (!scope.ngModelCtrl.$valid && !scope.ngModelCtrl.$pristine) {
	                            scope.error.showError = true;
	                        }

	                        scope.$apply();
	                    }, 20);
	                }, true);
	            }
	        };
	    };

	    // @ngInject
	    /**
	     * @param {ng.IFilterService} $filter
	     * @param {ng.IParseService} $parse
	     * @param {ng.ILocaleService} $locale
	     */
	    exports.metNumber = function ($filter, $parse, $locale, lpCoreI18n) {

	        function valueFormatter(value, fraction, currency, disabled) {
	            // make sure we have number value
	            if (angular.isString(value)) {
	                value = Number(value.replace(/[^0-9.\-+e]+/g, ''));
	            }

	            return disabled && currency ? lpCoreI18n.formatCurrency(value, currency) : $filter('number')(value, fraction);
	        }

	        return {
	            restrict: 'A',
	            require: 'ngModel',
	            link: function link(scope, element, attrs, ngModelCtrl) {

	                // get thousands separator and set number of digits after decimal point
	                var replaceRegex = new RegExp($locale.NUMBER_FORMATS.GROUP_SEP, 'g');
	                var fraction = 2;

	                ngModelCtrl.$parsers.push(function (viewValue) {
	                    if (viewValue) {
	                        // remove thousands separator
	                        var newVal = viewValue.toString().replace(replaceRegex, '');
	                        var newValAsNumber = parseFloat(newVal);

	                        // Do not check validity if disabled since when it's disabled we show the currency symbol
	                        if (!element.prop('disabled')) {

	                            // check if new value is numeric, and set control validity
	                            if (isNaN(newValAsNumber)) {
	                                ngModelCtrl.$setValidity('numeric', false);
	                            } else {
	                                newVal = newValAsNumber.toFixed(fraction);
	                                ngModelCtrl.$setValidity('numeric', true);
	                            }

	                            //check if new value is larger than the max value and set validity
	                            if (attrs.max && newValAsNumber > attrs.max) {
	                                ngModelCtrl.$setValidity('max', false);
	                            } else if (attrs.max) {
	                                ngModelCtrl.$setValidity('max', true);
	                            }

	                            //check if new value is smaller than the min value and set validity
	                            if (attrs.min && newValAsNumber < attrs.min) {
	                                ngModelCtrl.$setValidity('min', false);
	                            } else if (attrs.min) {
	                                ngModelCtrl.$setValidity('min', true);
	                            }
	                        }

	                        return newVal;
	                    }
	                });

	                ngModelCtrl.$formatters.push(function (data) {

	                    return valueFormatter(data, fraction, attrs.currency, element.prop('disabled'));
	                });

	                element.bind('focus', function () {
	                    element.val(ngModelCtrl.$modelValue);
	                });

	                function blurHandler() {
	                    var formatted = valueFormatter(ngModelCtrl.$modelValue, fraction, attrs.currency, element.prop('disabled'));

	                    ngModelCtrl.$setViewValue(formatted);

	                    ngModelCtrl.$render();
	                }

	                element.bind('blur', blurHandler);

	                element.bind('keypress', function (event) {
	                    // Code adpated from lp-number-input because it won't
	                    // work with other directive in the same element (scope isolation)
	                    // and also does not accept decimals
	                    // Regular expression for numbers 0..9 (and dot)
	                    var digitRegex = new RegExp('4[8-9]|5[0-7]');
	                    var isMinus = event.which === 45;
	                    var digit = null;
	                    var preValue;
	                    var input = element[0];

	                    // if key pressed not a digit, backspace, delete, enter, tab or function key... block it
	                    // check for 37 and 39, the left and right arrow key since some browsers trigger keypress for these
	                    if (!event.ctrlKey && !event.metaKey && !/^(8|9|13|189|190|45|46|37|39)$/.test(event.which || event.keyCode) && !digitRegex.test(event.which) && !isMinus) {
	                        return false;
	                    }

	                    var value = input.value;

	                    // Check if a dot is inputted, and if a dot is already at the string, block it
	                    if (event.which === 46 && (value.match(/\./g) || []).length > 0) {
	                        return false;
	                    }

	                    if (digitRegex.test(event.which) || isMinus) {
	                        digit = String.fromCharCode(event.which);

	                        // Check only if it's the first chracter (this.value is "")
	                        if (isNaN(value) && !this.value) {
	                            // If minus is the very first character just don't validate
	                            if (!isMinus) {
	                                value = '';
	                            }
	                        }

	                        preValue = value || this.value;

	                        // Additional check for minus character to make sure it can only be the very first character
	                        if (isMinus && (preValue || String(value || this.value).match(/-/g).length)) {
	                            return false;
	                        }

	                        value = parseInt(preValue + digit, 10);
	                    }
	                });

	                scope.$watch(function () {
	                    return element.prop('disabled');
	                }, blurHandler);
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject
	    /**
	     * @param {ng.ILogService} $log
	     */

	    exports.mbMessageValues = function ($log) {
	        return {
	            link: function link(scope, element) {
	                var notification = scope.notification;
	                if (!notification) {
	                    $log.warn('mb-message-values: $scope.notification does not exist. Aborting.');
	                    return false;
	                }
	                var message = notification.message;
	                element.html(message);
	            }
	        };
	    };

	    exports.metNotification = function () {
	        return {
	            restrict: 'E',
	            scope: {
	                level: '@',
	                icon: '@'
	            },
	            replace: true,
	            transclude: true,
	            template: '<div class="metro-notification">' + '   <div class="{{level}}">' + '       <div class="notification-item">' + '           <div class="metro-notification-icon-wrapper">' + '               <div class="metro-notification-icon">' + '                   <i class="fa fa-{{icon}}"></i>' + '               </div>' + '           </div>' + '           <div class="metro-notification-body">' + '               <div class="metro-notification-message" ng-transclude></div>' + '           </div>' + '       </div>' + '   </div>' + '</div>'
	        };
	    };

	    exports.metMessages = function () {
	        return {
	            restrict: 'E',
	            scope: {
	                messages: '=',
	                showDetail: '='
	            },
	            replace: true,
	            template: '<ul>' + '   <li ng-repeat="message in messages track by $index" data-notification-id="{{message.id}}" data-notification-category="{{message.category}}">' + '       <div class="metro-notification" data-ng-hide="!message.show">' + '           <div class="{{message.level}}">' + '               <div class="notification-item">' + '                   <div class="metro-notification-icon-wrapper">' + '                       <div class="metro-notification-icon">' + '                           <i class="fa fa-{{message.icon}}"></i>' + '                       </div>' + '                   </div>' + '                   <div class="metro-notification-body">' + '                       <div class="metro-notification-message" data-detail="{{message.detail}}"><span class="message"  ng-bind-html="message.message"></span> <span class="detail" ng-if="message.showDetail">{{message.detail}}</span></div>' + '                   </div>' + '               </div>' + '           </div>' + '           <div class="metro-notification-edit-link" ng-if="allowEdit && message.contentRef"><a ng-click="goTo(message)">Edit {{message.category}}/{{message.id}} <span ng-if="!message.show">(message is hidden)</span>  <span ng-if="message.showDetail">(IIB response shown)</span>  </a></div>' + '       </div>' + '   </li>' + '</ul>',
	            link: function link(scope) {
	                scope.allowEdit = b$.portal.loggedInUserRole === 'admin';
	                scope.goTo = function (message) {
	                    window.open('/portalserver/cxp-manager/shared-content//_/notifications/' + message.category + '/' + message.id + '?view=content', '_blank');
	                };
	            }
	        };
	    };

	    exports.metMessageSummary = function () {
	        return {
	            restrict: 'E',
	            scope: {
	                messageSummary: '='
	            },
	            replace: true,
	            template: '<div class="metro-notification-summary">' + '   <h4>{{heading}}</h4>' + '   <div data-ng-repeat="level in messageSummary" ng-show="level.messages.length > 0">' + '       <h5><i class="fa fa-{{level.icon}}"></i>{{level.title}}</h5>' + '       <p>{{level.description}}</p>' + '       <ul>' + '           <li data-ng-repeat="message in level.messages track by $index">{{message.itemDescription}} <br ng-if="message.itemDescription"/><span class="detail">{{message.detail}}</span></li>' + '       </ul>' + '   </div>' + '</div>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 * Directive for drawing tooltips
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.metTooltip = function (metTooltipFactory) {
	        return {
	            restrict: 'E',
	            scope: {
	                key: '@',
	                category: '@',
	                placement: '@',
	                inline: '@',
	                showTitle: '@'
	            },
	            link: function link(scope, element) {

	                scope.flags = {
	                    showMore: false,
	                    hasMore: false
	                };

	                scope.allowEdit = b$.portal.loggedInUserRole === 'admin';
	                scope.goTo = function () {
	                    if (scope.allowEdit) {
	                        window.open('/portalserver/cxp-manager/shared-content//_/tooltips/' + scope.tooltip.category + '/' + scope.tooltip.key + '?view=content', '_blank');
	                    }
	                };

	                function retrieveTooltip() {
	                    scope.tooltip = metTooltipFactory.getTooltip(scope.category, scope.key, scope.placement, scope.inline, scope.icon);
	                    if (scope.tooltip) {
	                        if (!scope.tooltip.inline) {
	                            var onMouseOver = function onMouseOver() {
	                                scope.showTooltip = true;
	                            };

	                            var onMouseOut = function onMouseOut() {
	                                scope.showTooltip = false;
	                            };
	                            element.on('mouseenter', onMouseOver);
	                            element.on('mouseleave', onMouseOut);
	                        } else {
	                            scope.flags.hasMore = scope.tooltip.expandable || false;
	                            scope.tooltipExtention = scope.tooltip.expandableContents || '';
	                            scope.title = scope.tooltip.title || '';
	                            scope.toggleView = function () {
	                                scope.flags.showMore = !scope.flags.showMore;
	                            };
	                        }
	                    }
	                }

	                retrieveTooltip();

	                if (scope.key) {
	                    scope.$watch('key', function () {
	                        retrieveTooltip();
	                    });
	                }
	            },
	            template: ['<span>', '    <a ng-if="!tooltip.inline"  href="javascript:void(0)" tabindex="-1" tooltip-trigger tooltip-placement="{{tooltip.placement}}" tooltip-html-unsafe="{{tooltip.contents}}" tooltip-popup-delay="100">', '        <i data-ng-click="goTo()" class="fa fa-{{tooltip.icon}}"></i>', '    </a>', '    <div ng-if="tooltip.inline" class="mb-tp">', '        <i ng-if="tooltip.icon" data-ng-click="goTo()"  class="fa fa-{{tooltip.icon}} tooltip-inline-icon"></i>', '        <span class="title" ng-if="tooltip.showTitle" ng-bind-html="tooltip.title"></span>', '        <span ng-bind-html="tooltip.contents"></span>', '        <div ng-if="flags.hasMore">', '            <span ng-bind-html="tooltip.expandableContents" ng-show="flags.showMore"></span>', '            <div class="expandable-switcher">', '                <a href="javascript:void(0)" tabindex="-1" ng-click="toggleView()" class="pull-left">{{flags.showMore ? \'-\' : \'+\'}}</a>', '                <hr/>', '            </div>', '        </div>', '    </div>', '</span>'].join('')
	        };
	    };

	    // @ngInject
	    exports.metWrappingTooltip = function (metTooltipFactory) {
	        return {
	            restrict: 'E',
	            replace: true,
	            transclude: true,
	            link: function link(scope, element, attrs) {
	                scope.category = attrs.category;
	                scope.key = attrs.key;
	                scope.showTooltip = false;
	                scope.placement = attrs.placement || 'top';

	                scope.tooltip = metTooltipFactory.getTooltip(scope.category, scope.key, scope.placement, scope.inline, scope.icon);

	                if (scope.tooltip) {
	                    var onMouseOver = function onMouseOver() {
	                        scope.showTooltip = true;
	                    };

	                    var onMouseOut = function onMouseOut() {
	                        scope.showTooltip = false;
	                    };
	                    element.on('mouseenter', onMouseOver);
	                    element.on('mouseleave', onMouseOut);
	                }
	            },
	            template: '<div style="display: inline-block;"  tooltip-placement="{{tooltip.placement}}" tooltip-html-unsafe="{{tooltip.contents}}" tooltip-popup-delay="100" ng-transclude></div>'

	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /**
	     * Directive for payments hardtoken
	     */

	    exports.metHardtoken = function () {

	        var template = ['<div class="hard-token">', '    <form name="hardtokenForm">', '        <label>Please enter your 8 digit hard token code</label>', '        <input', '            type="password"', '            parent-class="ct-hardtoken"', '            class="input-hardtoken"', '            ng-model="ngModel"', '            ng-pattern="/^[a-zA-Z0-9]*$/"', '            maxlength="8"', '            error-messages="hardTokenErrorMessages"', '            met-input required />', '    </form>', '</div>'].join('');

	        var link = function link(scope) {
	            scope.hardTokenErrorMessages = {
	                required: 'Please enter hardtoken'
	            };
	        };

	        return {
	            restrict: 'EA',
	            scope: {
	                ngModel: '='
	            },
	            link: link,
	            template: template
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 * Directives to handle input and scope.form styling and validation
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject
	    /**
	     * @param {ng.ICompileService} $compile
	     */

	    exports.metTh = function ($compile) {
	        return {
	            restrict: 'A',
	            transclude: true,
	            scope: {
	                label: '@',
	                sortBy: '@columnName',
	                sortCol: '=sortModel',
	                sortMethod: '&',
	                sortable: '='
	            },
	            link: function link(scope, elem) {

	                elem.addClass('met-th-elem');
	                var tmpl = '<a href ng-click="sortCol = sortBy; sortOrder = !sortOrder; sort()" class="sorter">' + '   <i ng-if="sortBy !== sortCol" class="fa fa-sort unsorted"></i>' + '   <i ng-if="sortBy == sortCol && sortOrder" class="fa fa-sort-asc"></i>' + '   <i ng-if="sortBy == sortCol && !sortOrder" class="fa fa-sort-desc"></i>' + '</a>';

	                var sorter = $compile(tmpl)(scope);

	                scope.sortOrder = false;

	                scope.getSortTerm = function (sortBy, order) {
	                    return (order ? '' : '-') + sortBy;
	                };

	                scope.sort = function () {
	                    var sorting = scope.getSortTerm(scope.sortBy, scope.sortOrder);
	                    scope.sortMethod({ param: sorting });
	                };

	                if (scope.sortable) {
	                    elem.prepend(sorter);
	                }
	            },
	            template: '<span class="header-label" ng-transclude></span>'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	  'use strict';

	  // @ngInject

	  exports.message = function () {
	    return {
	      restrict: 'E',
	      scope: {
	        message: '@',
	        type: '@'
	      },
	      template: '\n              <div ng-class="{\'error\': type === \'ERROR\' || type === \'INLINE-ERROR\'}" class="message">\n                <span ng-class="{\'message-type-error-icon\': type === \'ERROR\', \'message-type-inline-error-icon\': type === \'INLINE-ERROR\', \'message-type-warning-icon\': type === \'WARNING\', \'message-type-info-icon\': type === \'INFO\'}"></span>\n                <p ng-class="{\'message-type-error\': type === \'ERROR\', \'message-type-inline-error\': type === \'INLINE-ERROR\', \'message-type-warning\': type === \'WARNING\', \'message-type-info\': type === \'INFO\'}">{{message}}</p>\n              </div>\n              '
	    };
	  };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /**
	    * @type {ng.IAngularStatic}
	    */

	    var _ = __webpack_require__(39);

	    // @ngInject
	    exports.whyModal = function () {

	        return {
	            restrict: 'E',
	            scope: {
	                modalActive: '=',
	                closeModal: '=',
	                message: '@',
	                footerMessage: '@'
	            },
	            template: '\n            <div class="popUp" ng-show="modalActive">\n                <div class="modal-why-dialog modal-lg">\n                    <div class="modal-why-header">\n                        <div class="error-title"> Error </div>\n                        <hr class="why-modal">\n                    </div>\n                    <div class="modal-wrapper">\n                        <p>{{message}}</p>\n                        <p> {{ footerMessage }} </p>\n                        <button class="btn btn-default closing-modal-btn" ng-click="modalActive = false"> Close </button>\n                    </div>\n                </div>\n            </div>\n            '
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';
	    // @ngInject

	    exports.scamWarning = function (TEMPLATE_PATH) {
	        return {
	            restrict: 'E',
	            scope: {
	                startjourney: '=?startjourney',
	                request: '=?request',
	                submit: '&submit',
	                addjourney: '&addjourney',
	                endjourney: '&endjourney',
	                paymentjourney: '=?paymentjourney'
	            },

	            controller: /* @ngInject */function controller($scope, $filter, $timeout, $element, $log, metroTransmit, metroUiHandler, lpCoreBus, lpUsersAuthentication, metroContext, metroTagging, metroMeta) {
	                $scope.scamWarning_array = [{
	                    id: '1',
	                    name: 'Paying a bill or invoice for a service',
	                    heading: 'Were you expecting to make this payment?',
	                    desc: "Paying for a service from a new business or someone you’ve used before.",
	                    moredesc: "Making a payment for an bill/invoice – even if it’s from someone you’ve used before – confirm that the correspondence is genuine, and you're not communicating with a fraudster.",
	                    data: ['Ensure you & your employees verify any new or amended account details by contacting them in a different way to how they contacted you.', 'Phone numbers & email address can be manipulated - Check that the phone number and email address are exactly the same as the ones you have used before.', 'Have you received the goods/services you’re paying for?']
	                }, {
	                    id: '2',
	                    name: 'Buying Goods or Services in person or online',
	                    heading: 'Are you sure that what you’re paying for exists?',
	                    desc: "Paying for something to a new company or person you don’t know.",
	                    moredesc: "If you’re buying from a company or person you don’t know, do some research before sending money.",
	                    data: ['Never make a purchase away from the selling platform, as you will lose your buyer protection. Pay using your card or a secure payment platform.', 'Make sure independent reviews of the seller and product are positive & from genuine customers.', 'Don’t pay the full amount without seeing the product in a live environment – consider a deposit option.', 'Remember that if a deal seems too good to be true, it probably is']
	                }, {
	                    id: '3',
	                    name: 'Following payment instructions from your Boss or Employee?',
	                    heading: 'Have you been asked to urgently process a payment by a senior manager or amend an employee’s existing payment details?',
	                    desc: 'Making a payment following a request from ‘someone’ within your company.',
	                    moredesc: '',
	                    data: ['Double-check that it’s really them, by contacting them in a different way to how they contacted you. If you can’t speak to them, <b>DO NOT</b> make a payment.', 'Phone numbers & email address can be manipulated - Check that the phone number and email address are exactly the same as the ones you have used before.', 'Never make payments out of the ordinary or divert from your usual company process. Scammers will create elaborate stories to trick you into sending your money to them.']
	                }, {
	                    id: '4',
	                    name: 'Paying HMRC or a local authority',
	                    heading: 'Are you being pressurised in to acting quickly to make this payment?',
	                    desc: 'Making a payment to someone claiming to be HMRC, the police or an authority.',
	                    moredesc: 'If you weren’t expecting to make a payment and are being pressured or threatened – for example with fines or a prison sentence – <span class="text-red">STOP!</span>',
	                    data: ['<b>Never</b> make a payment of this type to an account with a personal name.', 'If you are making a scheduled payment to HMRC, make sure you check the account details on the official gov.uk website before sending.', 'Beware of ‘spoofing’: people can disguise their phone number to look like one you recognise', 'Government officials and local authorities will never call, email or text you demanding an immediate payment. ', 'If you are being pressured or threatened to make a payment –<b> DON’T.</b>']
	                }, {
	                    id: '5',
	                    name: "Moving money to another account or a ‘safe account’",
	                    heading: 'Have you had a call from ‘your bank’ and been told you must move money? Don’t – it’s a scam!',
	                    desc: 'You have been told to move your money to another account.',
	                    moredesc: 'If someone claims to be from Metro Bank, another bank or law enforcement and asks you to transfer money to a ‘safe’ account - it’s a fraudster.',
	                    data: ['Your bank or law enforcement will never call, email or text you demanding make any payments', 'Beware of ‘spoofing’: people can disguise their phone number to look like one you recognise.', 'Your bank or law enforcement will never open a new bank account on your behalf or ask you to support an investigation by handing money over.', 'Criminals may have basic information about you or your company (i.e. name, address, account details) - do not assume a caller is genuine because they have these details ', 'If you are being pressured or threatened to make a payment – <b>DON’T.</b>']
	                }, {
	                    id: '6',
	                    name: 'Make an investment or buying cryptocurrency',
	                    heading: 'Carry out research to ensure you’re investing via a FCA-registered firm or individual - If not, STOP!',
	                    desc: 'Making a payment to invest in a financial opportunity.',
	                    moredesc: 'If you’ve suddenly been contacted with an investment opportunity, it’s likely to be a scam.',
	                    data: ['Check that the company or stockbroker is FCA-registered. Always use the contact details from the FCA site, to avoid scammers who clone genuine company websites.', 'Avoid using your business account for Crypto related investments.', 'Remember that pressure to make a quick decision or returns seeming too good to be true, means this is likely to be a scam.']
	                }, {
	                    id: '7',
	                    name: 'Something else?',
	                    heading: 'Are you being rushed or into making this payment?',
	                    desc: "Paying for something you weren’t expecting to pay for.",
	                    moredesc: "Take time to think about the payment you’re making. ",
	                    data: ['Consider paying by card, or through a secure payment platform.', 'Criminals can impersonate people or companies by manipulating email addresses or phone numbers - Always verify who you’re speaking with by contacting them in a different way to how they contacted you.', 'A scammer will often guide you through the process and tell you what to do or apply fear and pressure tactics to encourage you to act quickly.', 'If you’ve been encouraged to choose this option by the person you’re communicating with – they’re likely to be a fraudster. <b>STOP</b> & think before sending any money']
	                }];
	                $scope.selObject = {};
	                $scope.scamWarning = true;
	                $scope.scamWarning_step1 = true;
	                $scope.scamWarning_step2 = false;
	                $scope.showAddPayeeBtn = true;
	                $scope.btnStyle = "btnDisable";
	                $scope.radioChecked = false;
	                $scope.scamWarning_selected_option = 0;

	                $scope.addben = function () {
	                    $scope.scamWarning_step1 = true;
	                    $scope.scamWarning_step2 = false;
	                    $scope.showAddPayeeBtn = true;
	                    $scope.radioChecked = false;
	                    $scope.btnStyle = "btnDisable";
	                    sessionStorage.setItem('payment_reason', $scope.scamWarning_selected_option);
	                    $scope.addjourney();
	                };
	                $scope.stopbenadding = function () {
	                    $scope.scamWarning_step1 = true;
	                    $scope.scamWarning_step2 = false;
	                    $scope.showAddPayeeBtn = true;
	                    $scope.radioChecked = false;
	                    $scope.btnStyle = "btnDisable";
	                    $scope.endjourney();
	                };
	                $scope.goto_scamWarning_step2 = function (val) {
	                    $scope.scamWarning_selected_option = val;
	                    $('.modal-content').scrollTop(0);
	                    $scope.scamWarning_step1 = false;
	                    $scope.scamWarning_step2 = true;
	                    $scope.request = $filter('filter')($scope.scamWarning_array, { id: val })[0];
	                };
	                $scope.backToStep1 = function () {
	                    if ($scope.scamWarning_step2) {
	                        $scope.scamWarning_step1 = true;
	                        $scope.scamWarning_step2 = false;
	                        $scope.showAddPayeeBtn = true;
	                        $scope.radioChecked = false;
	                        $scope.btnStyle = "btnDisable";
	                    } else {
	                        $scope.scamWarning = false;
	                        $scope.endjourney();
	                    }
	                };
	                $scope.enableAddPayee = function () {
	                    $scope.showAddPayeeBtn = !$scope.showAddPayeeBtn;
	                    $scope.btnStyle = $scope.radioChecked ? "btnDisable" : "btnEnable";
	                    $scope.radioChecked = !$scope.radioChecked;
	                };
	            },
	            templateUrl: TEMPLATE_PATH + 'scamWarning.html'
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    // @ngInject

	    exports.metAmountCurrency = function (lpCoreI18n) {

	        var CLASS_AMOUNT_NEGATIVE = 'lp-amount-negative';
	        var CLASS_AMOUNT_POSITIVE = 'lp-amount-positive';

	        function templateFn() {
	            return '<span class="{{signClass}}">{{formattedAmount}}</span>';
	        }

	        function linkFn(scope, element, attrs) {
	            function formatAmount() {
	                var amount = parseFloat(scope.amount);
	                scope.signClass = amount < 0 ? CLASS_AMOUNT_NEGATIVE : CLASS_AMOUNT_POSITIVE;
	                scope.currency = scope.currency ? scope.currency.trim() : '';
	                scope.formattedAmount = lpCoreI18n.formatCurrency(amount, scope.currency);
	                var re = /^\d*(\.\d+)?$/;
	                if (scope.formattedAmount.match(re)) {
	                    scope.formattedAmount = scope.currency + lpCoreI18n.formatCurrency(amount, scope.currency);
	                }
	            }
	            scope.$watch('amount', formatAmount);
	            scope.$watch('currency', formatAmount);

	            scope.$on('$localeChangeSuccess', formatAmount);
	        }

	        return {
	            restrict: 'E',
	            template: templateFn,
	            link: linkFn,
	            scope: {
	                'amount': '=mount',
	                'currency': '=mountCurrency'
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js